var _rect, _polygon, _path, _rect2, _polygon2, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.76,379.41a32.46,32.46,0,0,0-13.92-4.79c-2.27-.24-4.76-.17-6.58,1.21a1.35,1.35,0,0,0-.68,1.2,1.46,1.46,0,0,0,.65.82,19.89,19.89,0,0,0,20.53,1.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.41,379a67,67,0,0,1-9-7.91,22.71,22.71,0,0,1-5.64-10.42,4.18,4.18,0,0,1,.45-3.49C38.39,362.79,44,370,45.41,379",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.69,379.35a32.49,32.49,0,0,1,.17-11.8,16,16,0,0,1,6.28-9.74c1.24,2.89.71,6.23-.16,9.25a45,45,0,0,1-6.24,13.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.71,391.94c-4.26.52-8,2.77-11.16,5.65a21.08,21.08,0,0,0-6.38,11c4.18-.26,7.73-3.21,10.3-6.51s4.36-6.94,7.19-10",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.24,394a27.54,27.54,0,0,1,3.18-26c2.43,8.64,1.54,18.41-3.18,26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.52,405a19.89,19.89,0,0,0-19,10.95c-.24.48-.45,1.08-.13,1.5a1.42,1.42,0,0,0,1.26.37c3.75-.24,7.08-2.5,9.82-5.07s5.13-5.54,8.17-7.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.23,404.41a35.5,35.5,0,0,1-.36-19.81c.7-2.55,1.87-5.23,4.23-6.43a.82.82,0,0,1,.64-.11.83.83,0,0,1,.41.47,11.88,11.88,0,0,1,1,5.68,36.12,36.12,0,0,1-.89,5.76c-.74,3.51-1.14,7.29-3.07,10.32A21.52,21.52,0,0,0,64,402.56c-.37.77-.37,1-.7,1.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8,408.07c-1.82-6.93.11-15.32,4.47-21,.32-.42.75-.86,1.27-.82.81.08,1,1.15,1,2a38.07,38.07,0,0,1-6.72,19.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,409.58a30.53,30.53,0,0,0,25.06-5.1,20.26,20.26,0,0,0-13.56-1.66c-4.54,1-8.68,3.07-11.5,6.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88,405c4.71-7.68,13.74-12.7,22.74-13.15-1,3.66-4,6.5-7.44,8.22s-7.18,2.47-10.91,3.2c-1.46.28-3.45.59-4.39,1.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.26,382.6a65.76,65.76,0,0,0,2.91-13.32,22.17,22.17,0,0,0-2.65-13.18c-4.4,8.52-4.85,18.47-.39,27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.08,375.11c5.15-9.35,15.65-16.83,26.27-17.87-4.1,10.2-15.27,18.09-26.27,17.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.84,376.94c7.68,1.17,14.22,6.07,21.39,9.05a9.62,9.62,0,0,0,4.84.92,3.78,3.78,0,0,0,2.37-6.69,10.29,10.29,0,0,0-3.52-2.13c-7.81-3.26-16.19-3.34-24.42-1.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4,382.33c1.74.49,2.33,1.39,3.71,2.57a40.11,40.11,0,0,0,16.22,8.33c.62.15,1.43.21,1.74-.35s-.07-1.08-.42-1.51a22.34,22.34,0,0,0-9.79-6.65c-3.75-1.4-7-3.08-11.46-2.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.39,349.81a30.68,30.68,0,0,0,23.53,8,1.6,1.6,0,0,0,1.07-.39c.6-.64-.12-1.64-.81-2.17-6.91-5.4-15.29-7.63-23.79-5.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.33,347.64a32.79,32.79,0,0,1,29.37-4.85,23.24,23.24,0,0,1-14,6.14,44.3,44.3,0,0,1-15.37-1.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,332.7c-.68-6.91-.24-12.36-.72-19.3,0-.55-.16-1.22-.67-1.42-.73-.28-1.33.61-1.56,1.35A22.08,22.08,0,0,0,94,332.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.47,333.46a40.64,40.64,0,0,0,11.44-11.12c2.26-3.09,4.17-6.79,3.65-10.59a11,11,0,0,0-8.25,4.1,22.94,22.94,0,0,0-4.2,8.46c-.92,3-1.56,6.16-2.64,9.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.71,330.34a92.21,92.21,0,0,0,28.15-16.6c-3.36-1.36-7.21-.55-10.57.81a33.3,33.3,0,0,0-17.72,15.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.63,337.24c5.2.56,10.48.93,15.64.07s9.85-2.85,14.59-4.85a1.68,1.68,0,0,0,1-.75,1.13,1.13,0,0,0-.36-1.25,2.9,2.9,0,0,0-1.24-.58c-5.15-1.44-10.7-.77-15.77.94a73.13,73.13,0,0,0-13.85,6.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,350.05c-3.55-7.16-3.32-15.51-.25-22.89,2.15,3.29,2.42,7.47,2,11.38s-1.58,7.93-1.66,11.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8,342.9A31.91,31.91,0,0,0,29.08,353a22.18,22.18,0,0,0,13-2.41,66.1,66.1,0,0,0,11.13-7.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.27,339.72c-4.33-.35-8.49-.89-12.66.39A15.18,15.18,0,0,0,21,348.29a22.86,22.86,0,0,0,11.87-2.24,67.84,67.84,0,0,0,10.44-6.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.37,339.86c-3.89-2.55-7.89-5.15-12.43-6.2s-9.79-.28-13,3.14c3.68,2.15,8.13,2.41,12.39,2.4s9.48-.05,13.49,1.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4,340.07c-6.66-6.54-9.19-18.29-6.51-27.23a41.49,41.49,0,0,1,6.51,27.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.71,321.54c1.26-2.92,2.14-6,3.27-9a25.57,25.57,0,0,1,4.65-8.25,12.3,12.3,0,0,1,8.25-4.28,33.22,33.22,0,0,1-16,21.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4,325.4c-2.08-2.86-4.48-6.74-7.3-8.88s-6.49-3.43-9.93-2.61A23.1,23.1,0,0,0,72.4,325.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.06,321.78a49.44,49.44,0,0,1-3.29-10.64,16.62,16.62,0,0,1,1.67-10.82c3.65,6.91,4.83,14.33,1.8,21.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,300.32c2.07-6.85,8.35-11.9,15.12-14.21a5.63,5.63,0,0,1,2.65-.4,2.3,2.3,0,0,1,1.95,1.63c.25,1.17-.71,2.21-1.62,3a51.37,51.37,0,0,1-18.1,10",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.82,294.72c.26-4.42.54-8.9,2-13.09S82,273.52,86,271.69c.68,4.46-1.29,8.9-3.66,12.74s-5.23,7.46-6.66,11.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.71,297.76c-1.71-5-1.89-11.34-4.88-15.69-2.09-3-5.44-5.11-7.24-8.33A12.71,12.71,0,0,0,64,283.2a27.62,27.62,0,0,0,5.54,7.92c2.21,2.36,4.1,4.14,6.16,6.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,444.79c-.13,0-.25-33.3-.25-74.38s.09-74.39.22-74.39.25,33.3.26,74.39S75.88,444.79,75.74,444.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.85,345a7.19,7.19,0,0,1-1.25.47l-3.45,1.16c-2.91,1-6.9,2.43-11.23,4.2s-8.34,3.34-10.64,5.33A8,8,0,0,0,76.14,359c-.33.78-.39,1.26-.43,1.25s0-.12,0-.34a5.59,5.59,0,0,1,.25-1,7.49,7.49,0,0,1,2.08-3,18.78,18.78,0,0,1,4.62-2.87c1.85-.86,3.89-1.76,6.07-2.65,4.34-1.78,8.37-3.17,11.31-4.08,1.46-.46,2.66-.79,3.49-1A7.13,7.13,0,0,1,104.85,345Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.39,321.59a2.17,2.17,0,0,1-.35.37L113,323l-4,3.62L95.7,338.41c-5.18,4.62-9.66,9-12.77,12.35-1.55,1.66-2.78,3-3.61,4l-1,1.1c-.22.25-.34.38-.36.37a2.41,2.41,0,0,1,.29-.43c.2-.27.49-.67.89-1.16.8-1,2-2.41,3.51-4.1a168.26,168.26,0,0,1,12.7-12.47c5.2-4.61,9.94-8.74,13.38-11.72l4.09-3.52,1.13-.93C114.24,321.68,114.38,321.57,114.39,321.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1,343.11c-.13-.06,1-2.56,2-5.73s1.6-5.83,1.74-5.8a19.38,19.38,0,0,1-1.28,6,40.69,40.69,0,0,1-1.62,4A6.31,6.31,0,0,1,90.1,343.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.77,363.27a6.31,6.31,0,0,1-.8-.93c-.54-.7-1.22-1.58-2-2.62-1.72-2.23-4.1-5.29-6.76-8.65s-5.11-6.37-6.89-8.55l-2.09-2.59a5.44,5.44,0,0,1-.72-1,5.33,5.33,0,0,1,.86.86c.54.58,1.29,1.43,2.21,2.49,1.84,2.13,4.34,5.11,7,8.47s5,6.46,6.65,8.74c.83,1.14,1.48,2.07,1.93,2.72A5.47,5.47,0,0,1,75.77,363.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.39,355.07a11.61,11.61,0,0,1-2.67-5,14.3,14.3,0,0,1-.61-5.05l.21,0c-.09.38-.16.59-.2.58s0-.22,0-.62l.22,0a22.4,22.4,0,0,0,.85,4.91A36.86,36.86,0,0,0,69.39,355.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.15,344.71a9.12,9.12,0,0,0-1.86-1.09,12.68,12.68,0,0,0-5.19-.41,32.38,32.38,0,0,0-5.22.84,15.2,15.2,0,0,1-2.14.52,7,7,0,0,1,2-.84,23.75,23.75,0,0,1,5.28-1,11.23,11.23,0,0,1,5.34.58A3.27,3.27,0,0,1,61.15,344.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2,342.2c0,.07-1.09-.44-2.86-1a29.35,29.35,0,0,0-7.14-1.47,28.78,28.78,0,0,0-7.27.37c-1.85.33-3,.67-3,.59a2.94,2.94,0,0,1,.76-.32,17.38,17.38,0,0,1,2.16-.61,25.52,25.52,0,0,1,14.6,1.12,16.43,16.43,0,0,1,2,.92A2.81,2.81,0,0,1,59.2,342.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.71,331.58a60.68,60.68,0,0,1-2.09-7.25A62,62,0,0,1,72,317a57.39,57.39,0,0,1,2.09,7.24A59.61,59.61,0,0,1,75.71,331.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.84,331.58a32.87,32.87,0,0,0-2.31-4.34,18.84,18.84,0,0,0-3.4-3.51,3.12,3.12,0,0,1,1.31.67A10.67,10.67,0,0,1,73.92,327,9.57,9.57,0,0,1,75.84,331.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,427s-.15-.8-.52-2.22A31.17,31.17,0,0,0,73,419.06c-2.3-4.71-6.49-10.67-11.81-16.64-2.63-3-5.19-5.86-7.36-8.58a59.72,59.72,0,0,1-5.27-7.59,36.52,36.52,0,0,1-2.66-5.64c-.24-.69-.42-1.24-.52-1.61a2.86,2.86,0,0,1-.14-.58c.05,0,.29.77.84,2.12a40.7,40.7,0,0,0,2.77,5.54,65.19,65.19,0,0,0,5.32,7.49c2.18,2.69,4.74,5.51,7.39,8.53,5.33,6,9.51,12,11.75,16.81a28.57,28.57,0,0,1,2.1,5.87,15.15,15.15,0,0,1,.29,1.67A2.38,2.38,0,0,1,75.74,427Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,397.33a10.17,10.17,0,0,1-1.37.77,30.68,30.68,0,0,0-3.58,2.37,40.44,40.44,0,0,0-4.69,4.28c-1.65,1.74-3.35,3.76-5.08,5.93-3.47,4.35-6.71,8.19-8.65,11.26-1,1.53-1.7,2.81-2.17,3.71a10.94,10.94,0,0,1-.76,1.39,1.53,1.53,0,0,1,.13-.39c.1-.25.24-.62.46-1.08a36.4,36.4,0,0,1,2-3.81,125.57,125.57,0,0,1,8.56-11.38c1.74-2.17,3.46-4.2,5.13-5.94a39.36,39.36,0,0,1,4.82-4.25,25.72,25.72,0,0,1,3.69-2.25c.46-.23.83-.37,1.08-.48S102,397.31,102,397.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.56,407a20.61,20.61,0,0,1-2.91.42,38,38,0,0,0-6.91,1.36A20.62,20.62,0,0,0,86.55,412c-1.43,1.1-2.1,2-2.17,2a2.22,2.22,0,0,1,.44-.67,11,11,0,0,1,1.51-1.56,19,19,0,0,1,6.26-3.44,31.26,31.26,0,0,1,7-1.24A15.19,15.19,0,0,1,102.56,407Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.23,412.9c-.15-.09,1.17-2.09,2.18-4.79S88.59,403,88.77,403a5,5,0,0,1,0,1.56,17.26,17.26,0,0,1-.85,3.68,17.89,17.89,0,0,1-1.69,3.38A4.64,4.64,0,0,1,85.23,412.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.56,371.46a2.07,2.07,0,0,1-.46.24l-1.37.63c-.6.25-1.33.58-2.15,1s-1.78.86-2.78,1.46l-1.59.91c-.55.32-1.1.69-1.68,1.05-1.17.72-2.35,1.59-3.6,2.48a69.07,69.07,0,0,0-7.51,6.61,67.64,67.64,0,0,0-6.35,7.74c-.85,1.28-1.68,2.48-2.35,3.68-.35.59-.7,1.15-1,1.71s-.58,1.1-.85,1.62c-.57,1-1,2-1.37,2.83s-.7,1.57-.94,2.18L76,407a2.09,2.09,0,0,1-.24.48,3.37,3.37,0,0,1,.14-.51l.5-1.43a22.49,22.49,0,0,1,.87-2.22c.37-.85.76-1.84,1.3-2.87l.83-1.65c.29-.57.64-1.13,1-1.73.66-1.22,1.49-2.44,2.34-3.74a65.36,65.36,0,0,1,6.36-7.81,63.28,63.28,0,0,1,7.6-6.63c1.27-.89,2.46-1.76,3.65-2.46.58-.36,1.14-.73,1.7-1l1.61-.88c1-.59,2-1,2.83-1.41s1.58-.71,2.19-1l1.41-.54A2.12,2.12,0,0,1,110.56,371.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.75,385.4a3.33,3.33,0,0,1,1.14-1.7,7.21,7.21,0,0,1,4.61-1.77,12.63,12.63,0,0,1,4.86.95,6.83,6.83,0,0,1,1.83.89,11.27,11.27,0,0,1-2-.57,14.69,14.69,0,0,0-4.72-.79A7.58,7.58,0,0,0,91.11,384,12.47,12.47,0,0,0,89.75,385.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.64,388.61a17.45,17.45,0,0,0,1.3-4.26,17.1,17.1,0,0,0-.29-4.45,2.87,2.87,0,0,1,.54,1.25,8.61,8.61,0,0,1,.23,3.26,8.83,8.83,0,0,1-1,3.12C87,388.27,86.68,388.65,86.64,388.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.74,431.81c.72,12.73,4.55,25.67,10.45,38.76H88.85c5.62-13,9.2-25.88,9.83-38.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.52,452.41c0,.13-8.45.24-18.86.24s-18.87-.11-18.87-.24,8.45-.24,18.87-.24S94.52,452.27,94.52,452.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,457c0,.13-7.92.24-17.69.24s-17.68-.11-17.68-.24,7.91-.24,17.68-.24S94,456.89,94,457Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.61,440.17a72.89,72.89,0,0,1,0,11.82,72.89,72.89,0,0,1,0-11.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.35,440.17a78.15,78.15,0,0,1,0,12.24,78.15,78.15,0,0,1,0-12.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.26,440.06a81.37,81.37,0,0,1,0,12.49,81.37,81.37,0,0,1,0-12.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.87,440.17c0,.13-9.91.24-22.13.24s-22.13-.11-22.13-.24,9.91-.24,22.13-.24S97.87,440,97.87,440.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.54,
    y: 30.59,
    width: 76.86,
    height: 111.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.69,
    y: 30.59,
    width: 76.86,
    height: 111.4,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.24,
    y: 42.65,
    width: 57.76,
    height: 87.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,129.92s0-.15,0-.43,0-.7,0-1.23c0-1.1,0-2.71,0-4.79,0-4.18,0-10.28-.06-18,0-15.39-.05-37.18-.09-62.84l.19.19-57.75,0h0l.21-.21c0,32.92,0,63.28,0,87.27l-.17-.17,42,.09,11.62,0,3,0,1,0-1,0-3,0-11.57,0-42.15.09h-.16v-.17c0-24,0-54.35,0-87.27v-.21h.22l57.75,0h.19v.19c0,25.71-.07,47.55-.09,63,0,7.68,0,13.76,0,17.93,0,2.07,0,3.66,0,4.75,0,.53,0,.93,0,1.22S111,129.92,111,129.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.77,30.59a14.94,14.94,0,0,1-1.37,2c-.9,1.19-2.16,2.81-3.61,4.57s-2.8,3.31-3.8,4.42a13.38,13.38,0,0,1-1.69,1.72,14.59,14.59,0,0,1,1.47-1.92l3.7-4.49,3.69-4.49A14.14,14.14,0,0,1,120.77,30.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3,129.64a71.06,71.06,0,0,0,10.07,12.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37,142.24a11.76,11.76,0,0,1-1.76-1.6c-1-1-2.4-2.54-3.8-4.28a57,57,0,0,1-3.34-4.66,10.72,10.72,0,0,1-1.17-2.06,17.38,17.38,0,0,1,1.41,1.9c.85,1.19,2,2.81,3.43,4.55s2.71,3.26,3.69,4.35A17.4,17.4,0,0,1,121.37,142.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.68,141.9l10.07-12.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.75,129.48a77.07,77.07,0,0,1-4.87,6.34,76.79,76.79,0,0,1-5.2,6.08,77.07,77.07,0,0,1,4.87-6.34A74.63,74.63,0,0,1,53.75,129.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.69,30.59a67.41,67.41,0,0,1,4.89,5.84,70.14,70.14,0,0,1,4.56,6.1,71.36,71.36,0,0,1-4.89-5.84A70.14,70.14,0,0,1,43.69,30.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.67,
    y: 60.37,
    width: 19.34,
    height: 54.91,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.8,
    y: 30.59,
    width: 76.86,
    height: 111.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.95,
    y: 30.59,
    width: 76.86,
    height: 111.4,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.49,
    y: 42.65,
    width: 57.76,
    height: 87.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.25,129.92s0-.15,0-.43,0-.7,0-1.23c0-1.1,0-2.71,0-4.79,0-4.18,0-10.28,0-18,0-15.39-.06-37.18-.1-62.84l.19.19-57.75,0h0l.21-.21c0,32.92,0,63.28,0,87.27l-.17-.17,42.05.09,11.61,0,3.05,0,1.05,0-1,0-3,0-11.58,0-42.15.09h-.16v-.17c0-24,0-54.35,0-87.27v-.21h.22l57.75,0h.2v.19c0,25.71-.07,47.55-.09,63,0,7.68,0,13.76-.05,17.93,0,2.07,0,3.66,0,4.75,0,.53,0,.93,0,1.22S404.25,129.92,404.25,129.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,30.59a14.94,14.94,0,0,1-1.37,2c-.89,1.19-2.16,2.81-3.61,4.57s-2.8,3.31-3.8,4.42a13.38,13.38,0,0,1-1.69,1.72A15.82,15.82,0,0,1,405,41.37c1-1.25,2.3-2.78,3.7-4.49l3.7-4.49A13.72,13.72,0,0,1,414,30.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.55,129.64a71.51,71.51,0,0,0,10.07,12.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.62,142.24a11.47,11.47,0,0,1-1.75-1.6,53.3,53.3,0,0,1-3.8-4.28,55,55,0,0,1-3.35-4.66,10.72,10.72,0,0,1-1.17-2.06,15.91,15.91,0,0,1,1.41,1.9c.85,1.19,2,2.81,3.43,4.55s2.72,3.26,3.69,4.35A17.4,17.4,0,0,1,414.62,142.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.93,141.9,347,129.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,129.48a77.07,77.07,0,0,1-4.87,6.34,76.79,76.79,0,0,1-5.2,6.08,78.71,78.71,0,0,1,4.88-6.34A75.82,75.82,0,0,1,347,129.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,30.59a68.5,68.5,0,0,1,4.88,5.84,70.14,70.14,0,0,1,4.56,6.1,71.36,71.36,0,0,1-4.89-5.84A68.68,68.68,0,0,1,337,30.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.92,
    y: 60.37,
    width: 19.34,
    height: 54.91,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.17,
    y: 24.82,
    width: 123.64,
    height: 204.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.88,
    y: 33.89,
    width: 110.11,
    height: 186.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.27,
    y: 65.19,
    width: 116.2,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.62,91.94c.1.11-15.87,15.66-35.68,34.71S497,161.07,496.88,161s15.86-15.65,35.68-34.71S568.51,91.83,568.62,91.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.84,92.4c.1.11-10.06,10.18-22.7,22.48s-23,22.19-23.08,22.08,10.05-10.18,22.69-22.48S546.73,92.29,546.84,92.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.6,
    y: 24.82,
    width: 123.64,
    height: 204.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.3,
    y: 33.89,
    width: 110.11,
    height: 186.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.7,
    y: 65.19,
    width: 116.2,
    height: 8.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697,91.94c.11.11-15.86,15.66-35.67,34.71s-36,34.42-36.06,34.31,15.86-15.65,35.67-34.71S696.93,91.83,697,91.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.26,92.4c.11.11-10,10.18-22.69,22.48s-23,22.19-23.08,22.08,10-10.18,22.69-22.48S675.15,92.29,675.26,92.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "619.98 411.27 620.58 410.23 611.1 412.28 619.98 470.36 625.22 470.36 619.98 411.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.29,356a7.1,7.1,0,0,0-5.51,7.2c.3,7.55,1.24,20.77,4.24,28.51,4.37,11.3,5.46,15.67,13.84,15.31s126.44,0,126.44,0,10.56.36,14.94-14.94,14.21-74.7,8.74-85.26-28.78-13.85-39-13.12-29.13-2.21-53.9,28.76l-24.43,27.86A228.9,228.9,0,0,0,557.29,356Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639,309.55l-23.59,66.08H571.69s-3.46-22.2-9.81-20.61c0,0,32-5.33,40.78-4.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.67,407.47s4.73-6.22,6.92-17.51,7.65-35.34-3.46-35c0,0,32.24,1,38.8-4.23s25-40.72,25-40.72,1.76,13.35-1,33-6.59,43.24-9.13,50.25c-1.92,5.29-5.19,12.85-14.48,13.65C686.5,407.8,653.67,407.47,653.67,407.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.3,406.85s2.17,6.64,15.92,6.64h93.84s11.9-.27,15.24-6.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.59,390a1.45,1.45,0,0,1,.06-.34c.06-.26.14-.59.23-1l.87-3.81a99.06,99.06,0,0,0,2.09-14.23,32.2,32.2,0,0,0-.67-9.83,8,8,0,0,0-2.75-4.49c-1.47-1.13-3.53-1.1-5.45-.78a11.59,11.59,0,0,0-5.39,2.58,18.08,18.08,0,0,0-4,4.89,37.25,37.25,0,0,0-4.25,12.72l-.05.28h-1.22l-48.35-.09-14.65-.1-4-.06-1,0a.18.18,0,1,1,0-.06l1,0,4-.06,14.65-.1,48.35-.1h1l-.32.28A37.69,37.69,0,0,1,645,362.64a18.39,18.39,0,0,1,4.16-5.05,12.07,12.07,0,0,1,5.67-2.69,11.39,11.39,0,0,1,1.53-.18l.76,0,.77.07a7,7,0,0,1,1.49.32c.24.09.46.22.69.33a2.65,2.65,0,0,1,.64.4,8.42,8.42,0,0,1,2.93,4.8,32,32,0,0,1,.61,10,91,91,0,0,1-2.3,14.26c-.39,1.66-.74,2.93-1,3.8-.12.4-.22.72-.3,1A1.68,1.68,0,0,1,660.59,390Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "579 410.23 579.61 411.27 574.36 470.36 579.61 470.36 588.48 412.28 579 410.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "645.56 411.27 646.16 410.23 636.68 412.28 645.56 470.36 650.8 470.36 645.56 411.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "681.9 411.27 682.5 410.23 673.03 412.28 687.14 470.36 692.39 470.36 681.9 411.27",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703.68,471.24c0,.14-147.17.26-328.66.26s-328.7-.12-328.7-.26S193.45,471,375,471,703.68,471.09,703.68,471.24Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.6,178.73l-7.46-1.48a22.68,22.68,0,1,1,6.46-4.95h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.6,178.73a2.71,2.71,0,0,1-.09-.44c0-.31-.13-.72-.22-1.24-.19-1.12-.46-2.7-.8-4.74l.18.08h0a.11.11,0,0,1-.16,0,.1.1,0,0,1,0-.14A22.57,22.57,0,0,0,127,135.49a23,23,0,0,0-10.37-.45,22,22,0,0,0-9.85,4.55,22.48,22.48,0,0,0,24.27,37.55.11.11,0,0,1,.08,0l5.5,1.17,1.43.31.51.12a2.48,2.48,0,0,1-.46-.07l-1.42-.25-5.61-1h.08a22.46,22.46,0,0,1-10.9,2.56,22.92,22.92,0,0,1-13.85-40.79,22.58,22.58,0,0,1,10.12-4.67,23.4,23.4,0,0,1,10.62.49,23.13,23.13,0,0,1,14.31,12.22,22.77,22.77,0,0,1-3.81,25.2l-.15-.18h0a.11.11,0,0,1,.16,0,.17.17,0,0,1,0,.05c.29,2.09.52,3.71.67,4.84.07.52.13.92.17,1.23S138.6,178.74,138.6,178.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.68,156.25a6,6,0,0,0-1.43-3.32,5.83,5.83,0,0,0-3-2,4.75,4.75,0,0,0-3.67.6,4.63,4.63,0,0,0-1.54,1.63,4.65,4.65,0,0,0-5-2.38,5.84,5.84,0,0,0-3.07,1.75,6.09,6.09,0,0,0-1.65,3.22,7.4,7.4,0,0,0,.76,4.53,10.38,10.38,0,0,0,3.46,3.45c2.28,1.48,5.29,3.34,5.29,3.34s2.66-1.85,5-3.18a10.39,10.39,0,0,0,3.68-3.22A7.29,7.29,0,0,0,130.68,156.25Z",
    style: {
      fill: "#845EC2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--serum-bag--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.56,
    y: 91.85,
    width: 36.57,
    height: 55.04,
    rx: 3.18,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,146.89a3.81,3.81,0,0,0,1.68-.55,3.14,3.14,0,0,0,1.26-1.68,3.65,3.65,0,0,0,.14-1.35c0-.5,0-1,0-1.6,0-4.52-.05-11-.09-19,0-4,0-8.43,0-13.16,0-2.36,0-4.81,0-7.32,0-1.26,0-2.54,0-3.83v-2a15.14,15.14,0,0,0-.06-1.93,2.92,2.92,0,0,0-2.54-2.34c-1.31,0-2.73,0-4.1,0H158.74a2.91,2.91,0,0,0-2.88,2.51c-.05,1.44,0,3,0,4.48v8.82c0,5.79,0,11.37,0,16.69s0,10.37,0,15.1c0,1.18,0,2.34,0,3.48A3.12,3.12,0,0,0,156.9,146a2.92,2.92,0,0,0,1.37.6,11.41,11.41,0,0,0,1.56.05h3.09l19,.09,5.18.05,1.35,0,.46,0-.46,0-1.35,0L182,147l-19,.09h-3.09a12.94,12.94,0,0,1-1.63,0,3.41,3.41,0,0,1-2.62-2.09,4.25,4.25,0,0,1-.25-1.75v-3.48c0-4.73,0-9.79,0-15.1s0-10.9,0-16.69V99.12c0-1.51,0-3,0-4.55a3.47,3.47,0,0,1,3.43-3h26.43c1.4,0,2.74,0,4.15,0a3.47,3.47,0,0,1,3,2.76,15.65,15.65,0,0,1,.06,2v2c0,1.29,0,2.57,0,3.83,0,2.51,0,5,0,7.32,0,4.73,0,9.13,0,13.16,0,8-.07,14.52-.09,19,0,.57,0,1.1,0,1.6a4,4,0,0,1-.17,1.4,3.27,3.27,0,0,1-1.36,1.72,3,3,0,0,1-1.28.45A2.26,2.26,0,0,1,189,146.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.47,85.17a3.24,3.24,0,0,1-.44,0,9.4,9.4,0,0,1-5.87-3.42,4.26,4.26,0,0,0-3.2-1.44H183.38a5.34,5.34,0,0,0-3.64,1.46c-1.62,1.51-4.11,3.32-6.8,3.32-3.4,0-5.85-3-6.76-6l2.88-.87c.48,1.57,1.91,3.9,3.88,3.9,1.33,0,3-.89,4.74-2.5a8.32,8.32,0,0,1,5.7-2.28H244a7.33,7.33,0,0,1,5.46,2.46,6.7,6.7,0,0,0,3.92,2.42c1.61.17,3.56-3.62,4.34-6.43l2.9.8C260.33,77.43,258.07,85.17,253.47,85.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.03,
    y: 51.66,
    width: 7.87,
    height: 407.87,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,459.54c0-1.52-.06-45.49-.16-119.06,0-73.75-.07-175.75-.12-288.82v-.27h8.43v.27c-.11,202.88-.21,371.72-.23,407.88v0h0l-7.87,0,7.87-.05-.05.05c0-36.16-.11-205-.23-407.88l.28.28H207l.28-.28c0,113-.08,214.92-.11,288.61S207,458,207,459.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.15,462H239.1a4.79,4.79,0,0,0-4.79-4.8H182.94a4.79,4.79,0,0,0-4.79,4.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.39,
    cy: 466.36,
    r: 6.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.68,
    cy: 466.36,
    r: 6.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.62,
    cy: 466.41,
    r: 6.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.14,79.45c-.08.13-.57-.18-.49-.82s.68-.79.72-.64-.16.38-.2.72S213.24,79.35,213.14,79.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,100c-.14,0-.26-6.87-.26-15.35s.12-15.36.26-15.36.26,6.87.26,15.36S207.18,100,207,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.86,
    y: 115.39,
    width: 28.87,
    height: 27.27,
    rx: 2.13,
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.78,
    y: 123.35,
    width: 18.3,
    height: 5.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.79,95.06a2,2,0,1,1-2-2A2,2,0,0,1,175.79,95.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.44,95.63a40.62,40.62,0,0,0-.37-14.54c-.17-.84-1.46-.48-1.29.36a38.73,38.73,0,0,1,.37,13.83c-.13.84,1.16,1.2,1.29.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.73,
    y: 91.85,
    width: 36.57,
    height: 55.04,
    rx: 3.18,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.12,146.89a3.77,3.77,0,0,0,1.68-.55,3.15,3.15,0,0,0,1.27-1.68,3.87,3.87,0,0,0,.14-1.35c0-.5,0-1,0-1.6,0-4.52-.05-11-.08-19,0-4,0-8.43,0-13.16,0-2.36,0-4.81,0-7.32,0-1.26,0-2.54,0-3.83v-2a15.14,15.14,0,0,0-.06-1.93,2.92,2.92,0,0,0-2.55-2.34c-1.3,0-2.72,0-4.1,0H238.92A2.91,2.91,0,0,0,236,94.64c-.06,1.44,0,3,0,4.48v8.82c0,5.79,0,11.37,0,16.69s0,10.37,0,15.1c0,1.18,0,2.34,0,3.48a3.13,3.13,0,0,0,1.11,2.82,3,3,0,0,0,1.38.6,11.41,11.41,0,0,0,1.56.05h3.08l19,.09,5.18.05,1.35,0,.45,0-.45,0-1.35,0-5.18.05-19,.09H240a12.94,12.94,0,0,1-1.63,0,3.32,3.32,0,0,1-1.57-.69,3.39,3.39,0,0,1-1.05-1.4,4.25,4.25,0,0,1-.25-1.75c0-1.14,0-2.3,0-3.48,0-4.73,0-9.79,0-15.1s0-10.9,0-16.69V99.12c0-1.51,0-3,0-4.55a3.47,3.47,0,0,1,3.43-3h26.42c1.41,0,2.74,0,4.16,0a3.47,3.47,0,0,1,3,2.76,15.65,15.65,0,0,1,.06,2c0,.66,0,1.31,0,2v3.83c0,2.51,0,5,0,7.32,0,4.73,0,9.13,0,13.16,0,8-.07,14.52-.09,19,0,.57,0,1.1,0,1.6a4,4,0,0,1-.17,1.4,3.24,3.24,0,0,1-1.37,1.72,2.94,2.94,0,0,1-1.27.45A2.38,2.38,0,0,1,269.12,146.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.03,
    y: 115.39,
    width: 28.87,
    height: 27.27,
    rx: 2.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.96,
    y: 123.35,
    width: 18.3,
    height: 5.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,95.06a2,2,0,1,1-2-2A2,2,0,0,1,256,95.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.62,95.63a40.85,40.85,0,0,0-.37-14.54c-.18-.84-1.46-.48-1.29.36a38.73,38.73,0,0,1,.37,13.83c-.13.84,1.16,1.2,1.29.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.57,111.56c.24.21-4.07,4.58-9.53,9.77-2.73,2.6-5.23,4.91-7.06,6.57-.92.83-1.67,1.49-2.2,1.94a4.27,4.27,0,0,1-.85.66s.23-.32.71-.82l2.07-2.06c1.76-1.73,4.22-4.1,6.95-6.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,107.6c.09.12-3.88,3.44-8.88,7.41s-9.14,7.09-9.23,7,3.88-3.43,8.88-7.41S264.93,107.48,265,107.6Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.62,96.79A4.91,4.91,0,0,0,497.67,94a6.7,6.7,0,0,0-8.25-.31,6,6,0,0,0-9.27,4.35c-2.68,1.26-4.53,1.18-5.35,2.33a4.91,4.91,0,0,0,.52,5.81,4.79,4.79,0,0,0,1.49,9.42l24.6-13.28A4.9,4.9,0,0,0,502.62,96.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.08,116.25a20.34,20.34,0,0,1,21.3-17.52l1.05.06c11.29,1.31,16.5,11.63,14.88,22.89l-3.8,37.65-.2,1.83-26.46,3.75.59-9.61s-10.8-2.32-10.31-13.22C473.36,136.81,474.73,126,476.08,116.25Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.35,155.27a26.43,26.43,0,0,0,14.51-3.36s-3.8,7.65-14.62,6.05Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.36,126.86a1.57,1.57,0,0,0,1.41,1.66,1.5,1.5,0,0,0,1.69-1.32,1.56,1.56,0,0,0-1.41-1.65A1.49,1.49,0,0,0,478.36,126.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.11,121.71c.19.21,1.41-.59,3.09-.49s2.85,1,3,.81-.08-.46-.59-.88a4.21,4.21,0,0,0-2.42-.9,4.07,4.07,0,0,0-2.47.64C478.22,121.26,478,121.61,478.11,121.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.14,128a1.56,1.56,0,0,0,1.41,1.66,1.49,1.49,0,0,0,1.68-1.31,1.55,1.55,0,0,0-1.41-1.66A1.48,1.48,0,0,0,493.14,128Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.55,123c.19.21,1.42-.59,3.09-.49s2.85,1,3,.81-.07-.46-.59-.88a4.21,4.21,0,0,0-2.42-.9,4.07,4.07,0,0,0-2.47.64C494.66,122.51,494.46,122.86,494.55,123Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.77,135a11.23,11.23,0,0,0-2.69-.65c-.43-.06-.83-.17-.88-.47a2.19,2.19,0,0,1,.36-1.25l1.45-3.18c2-4.54,3.5-8.28,3.32-8.36s-2,3.53-4,8.07c-.49,1.12-.95,2.19-1.4,3.21a2.41,2.41,0,0,0-.31,1.66,1,1,0,0,0,.66.67,3.13,3.13,0,0,0,.72.14A11.08,11.08,0,0,0,487.77,135Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.63,136.47c-.27,0-.38,1.78-2,3s-3.55.89-3.58,1.14.41.38,1.23.45a4.52,4.52,0,0,0,3-.86,3.9,3.9,0,0,0,1.57-2.51C492.93,136.93,492.76,136.46,492.63,136.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.5,116.37c.13.47,1.82.35,3.77.7s3.51,1,3.79.58c.13-.19-.12-.64-.74-1.11a6.66,6.66,0,0,0-5.76-1C494.82,115.82,494.44,116.15,494.5,116.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.16,116.89c.28.4,1.45.07,2.84.13s2.55.4,2.84,0c.13-.19,0-.58-.53-1a4.13,4.13,0,0,0-4.57-.12C478.23,116.32,478,116.7,478.16,116.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.3,110.63s3.26-6.66,6.64-8.07c4.1-1.7,5.56,2.77,9.42,1.93s7.76-2.48,11.47.67c4.07,3.46,1.95,5.6,1.94,10.45-.06,19.66,3.21,25.4,4.75,16.23.17-1,3-1.65,3.68-5.9.86-5.51,1.45-12.23.44-16.23-.85-3.37-2.61-5.77-5.86-8.49-5.12-4.29-12.46-4.79-17.48-4.57S477.33,102.06,477.3,110.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,132.18a3,3,0,0,1,3.36-2.66c2,.31,4.21,1.59,3.84,5.78-.66,7.43-8,5.24-8,5S510.65,135.29,511,132.18Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,137.67s.12.1.33.22a1.3,1.3,0,0,0,1,.11,3.24,3.24,0,0,0,1.74-2.75,4.28,4.28,0,0,0-.2-1.88,1.5,1.5,0,0,0-.88-1.08.66.66,0,0,0-.8.28c-.12.2-.08.35-.13.36s-.14-.14-.06-.44a.89.89,0,0,1,.34-.44,1,1,0,0,1,.73-.12,1.82,1.82,0,0,1,1.25,1.27,4.58,4.58,0,0,1,.27,2.11c-.19,1.5-1.08,2.83-2.18,3.05a1.38,1.38,0,0,1-1.17-.31C512,137.85,512,137.68,512,137.67Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.63,117.75a7.18,7.18,0,0,1-3.24,1.27,2.43,2.43,0,0,1-2.6-1.86c-.06-.52.1-1.12-.21-1.54s-1.14-.39-1.77-.36a4.76,4.76,0,0,1-4.74-3.69,2,2,0,0,1-2.69.1,10.57,10.57,0,0,1-1.91-2.29A3.06,3.06,0,0,0,492,108a7.88,7.88,0,0,1-1.64.26c-1-.14-1.39-1.31-1.48-2.29s-.14-2.12-.94-2.7-1.75-.3-2.66-.22-2.06-.2-2.24-1.09a1.78,1.78,0,0,1,.41-1.33,4.83,4.83,0,0,1,5.8-1.5,6.55,6.55,0,0,1,12.09-.59,6.64,6.64,0,0,1,10.46,3,4.82,4.82,0,0,1,5,7.3,4.58,4.58,0,0,1,2.3,3.78c-.06,1.55-1.64,3-3.11,2.51a2.67,2.67,0,0,1-4.76,2.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.56,115.13a1.84,1.84,0,0,1-.55,1.41,2.41,2.41,0,0,1-1.54.8,2.61,2.61,0,0,1-2.09-.74l.32,0a7.74,7.74,0,0,1-1.59,1.78,4.39,4.39,0,0,1-1.41.76,2.89,2.89,0,0,1-1.51.06,3,3,0,0,1-2.08-1.36,4.35,4.35,0,0,1-.51-1.58c-.05-.39-.05-.6,0-.61a2.09,2.09,0,0,1,.18.57,5.13,5.13,0,0,0,.61,1.46,3,3,0,0,0,4.47.36,7.61,7.61,0,0,0,1.52-1.66l.14-.21.18.18a2.2,2.2,0,0,0,1.76.67,2.18,2.18,0,0,0,1.39-.63A3.81,3.81,0,0,0,516.56,115.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.45,97.32s-.19,0-.54.16a2.59,2.59,0,0,0-1.21.92l-.1.13-.09-.14a9.26,9.26,0,0,0-3.44-3.12,7.3,7.3,0,0,0-2.89-.81,6,6,0,0,0-3.21.72,6.21,6.21,0,0,0-2,1.67,5.08,5.08,0,0,0-.94,2.2l0,.24-.22-.08a4.19,4.19,0,0,0-3.12.2,4.07,4.07,0,0,0-1.8,1.72,5.8,5.8,0,0,0-.59,2.18,1.83,1.83,0,0,1,0-.61,4.12,4.12,0,0,1,.43-1.68,4.24,4.24,0,0,1,1.86-1.91,4.48,4.48,0,0,1,3.39-.27l-.26.16a5.38,5.38,0,0,1,1-2.4,6.48,6.48,0,0,1,2.11-1.8A6.4,6.4,0,0,1,495.2,94a7.56,7.56,0,0,1,3.05.9,9.1,9.1,0,0,1,3.46,3.33h-.2a2.53,2.53,0,0,1,1.37-.9C503.25,97.27,503.45,97.3,503.45,97.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.13,137.7c-.12,0-.12-.79-.72-1.48s-1.35-.84-1.33-1,.21-.1.55,0a2.22,2.22,0,0,1,1.11.71,2.13,2.13,0,0,1,.51,1.22C495.27,137.51,495.18,137.71,495.13,137.7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.91,135.68c-.11.06-.36-.22-.75-.42s-.75-.27-.76-.39.45-.26,1,0S496,135.64,495.91,135.68Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.1,236.18s-4.74-5-6.5-6-7.89-3.29-9.83-5.3a1.67,1.67,0,0,0-.82,2.76,18.91,18.91,0,0,0,5.65,5.17c1.51.77.8,1.83-.43,2s-9.68.09-9.68.09-9.58-1.54-10.53-.71a1.7,1.7,0,0,0,.18,2.66c.52.3,8.61,2.34,8.61,2.34l4.3.27s-13.52,0-14.47,1a1.47,1.47,0,0,0,.16,2.36c.6.52,6.57.45,6.57.45l8,.46-15,1.48s-1.4.32-1.32,1.45,1.8,1.68,1.8,1.68l15.65-.17s-8.31,3.83-8.69,4.46c-.51.84.86,2,1.52,1.68s10.88-2.6,10.88-2.6l11.75-3,7.17,1.4-.69-13.88Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.21,255.18l-30.75-6.09,2.94-12.74,34.21-.65-.32-25.11,23.44-1.09a232.28,232.28,0,0,1-1.17,35.85s-.23,10-11.73,10.69A102.16,102.16,0,0,1,477.21,255.18Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.1,435.21v35l-46.08.11c.24-4.16,24-12.57,24-12.57l-1-22.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.3,455.83a1.78,1.78,0,0,1,1.31,2,1.81,1.81,0,0,1-2.11,1.24,1.88,1.88,0,0,1-1.38-2.16,1.91,1.91,0,0,1,2.35-1.06",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.1,470.21l-.15-3.53-44.13,1.43s-2,.85-1.8,2.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M464,457.82c0,.22,1.13.31,2.24,1s1.71,1.58,1.92,1.49-.14-1.31-1.5-2.11S463.94,457.63,464,457.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.71,459.79c0,.2.93.56,1.69,1.46s1,1.85,1.22,1.84.36-1.22-.61-2.31S458.71,459.58,458.71,459.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.93,465.25c.2,0,.51-1-.07-2.18s-1.64-1.63-1.74-1.45.56.8,1,1.76S455.7,465.23,455.93,465.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.91,453.38c.09.2,1.12-.1,2.4,0s2.26.46,2.38.27-.84-.94-2.34-1S463.8,453.22,463.91,453.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.76,447.23a4.79,4.79,0,0,0,2.31,0,10.8,10.8,0,0,0,2.41-.71,10.16,10.16,0,0,0,1.32-.66,2.93,2.93,0,0,0,.7-.52.9.9,0,0,0,.09-1.13,1.21,1.21,0,0,0-1-.48,3.1,3.1,0,0,0-.86.11,8.56,8.56,0,0,0-1.43.47,8.22,8.22,0,0,0-2.12,1.32c-1.07.94-1.43,1.74-1.35,1.78s.62-.6,1.7-1.37a8.89,8.89,0,0,1,2-1.1,7.9,7.9,0,0,1,1.33-.39c.48-.13.9-.13,1,.08s.05.1-.05.24a2.5,2.5,0,0,1-.51.37,11.43,11.43,0,0,1-1.22.67,13.36,13.36,0,0,1-2.23.81A15.22,15.22,0,0,0,464.76,447.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.06,447.53a3.34,3.34,0,0,0,.59-2.11,6.61,6.61,0,0,0-.32-2.38,7.09,7.09,0,0,0-.6-1.33,1.87,1.87,0,0,0-1.48-1.09,1.07,1.07,0,0,0-1,.61,2.64,2.64,0,0,0-.23.8,4.46,4.46,0,0,0,0,1.46,5,5,0,0,0,1,2.26c.91,1.12,1.85,1.37,1.87,1.3s-.71-.51-1.41-1.6a4.84,4.84,0,0,1-.74-2,4.11,4.11,0,0,1,0-1.26c.07-.47.25-.84.43-.79s.62.34.81.71a7.15,7.15,0,0,1,.58,1.18,7.69,7.69,0,0,1,.46,2.17C465.17,446.7,464.93,447.5,465.06,447.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.69,420.47l19.22,24.47-32.14,25.38c-2.11-3,9.9-22,9.9-22l-13-15.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.56,439.17a1.58,1.58,0,0,1,2,.7,1.6,1.6,0,0,1-.79,2,1.65,1.65,0,0,1-2.14-.75,1.69,1.69,0,0,1,1.05-2",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.91,444.94l-2-2.39-30,25.23s-1,1.72-.05,2.54Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M526.62,448.59c.13.14,1-.41,2.11-.54s2.06.16,2.16,0-.82-.85-2.21-.66S526.48,448.48,526.62,448.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.07,452.89c.08.17,1-.11,2,.09s1.71.75,1.86.62-.41-1.05-1.7-1.28S524,452.75,524.07,452.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525,458.21c.17-.08-.2-1-1.25-1.48s-2-.24-2-.06.83.25,1.68.66S524.85,458.32,525,458.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.11,445.1c.17.09.73-.69,1.66-1.33s1.83-.92,1.81-1.12-1.1-.19-2.19.58S523.94,445.05,524.11,445.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.38,440.59c0,.06.74-.33,1.6-1.28a9.61,9.61,0,0,0,1.3-1.82,10.13,10.13,0,0,0,.56-1.19,2.54,2.54,0,0,0,.2-.74.78.78,0,0,0-.55-.84,1.1,1.1,0,0,0-1,.2,2.8,2.8,0,0,0-.54.56,8.33,8.33,0,0,0-.75,1.11,7.6,7.6,0,0,0-.75,2.09,3.26,3.26,0,0,0,0,2c.11,0,.11-.75.44-1.89a8.39,8.39,0,0,1,.83-1.9,8.79,8.79,0,0,1,.71-1c.27-.35.56-.58.76-.51s.1.05.1.2a1.64,1.64,0,0,1-.15.54,8.94,8.94,0,0,1-.49,1.13,12,12,0,0,1-1.1,1.8C521.89,440,521.31,440.51,521.38,440.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.75,440.64c.08,0,0-.79-.74-1.8a5.94,5.94,0,0,0-1.54-1.49,6.8,6.8,0,0,0-1.14-.6,1.66,1.66,0,0,0-1.63.05,1,1,0,0,0-.34.95,2.43,2.43,0,0,0,.28.69,3.92,3.92,0,0,0,.81,1,4.36,4.36,0,0,0,1.93,1,2.67,2.67,0,0,0,2-.11,16.8,16.8,0,0,1-1.86-.35,4.31,4.31,0,0,1-1.64-1,3.77,3.77,0,0,1-.67-.9c-.21-.36-.28-.73-.13-.79a1.17,1.17,0,0,1,1,.05,5.68,5.68,0,0,1,1.05.51,6.63,6.63,0,0,1,1.52,1.27C521.38,440,521.65,440.69,521.75,440.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.89,278.69l-.2,2.36a81.48,81.48,0,0,1-3.12,16.46l-.21.67a29.57,29.57,0,0,1-7.29,12.49c-3.56,3.63-7.74,7.93-8.42,8.77l-16.13,55.43,5.12,73.48-29.26,2.45s-12.71-74.91-11-86.56,12.26-89.35,12.26-89.35l3-5.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.92 321.46 500.75 375.6 540.54 427.94 516.39 444.98 462.87 384.46 461.22 313.48 496.92 321.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.65,319.44a1.87,1.87,0,0,0-.11.26c-.06.2-.15.45-.26.77l-1,3c-.83,2.63-2,6.38-3.49,11.05-2.94,9.44-7,22.55-11.63,37.42V372c.21,3.17.44,6.48.66,9.86,1.25,17.85,2.37,34,3.19,45.75.43,5.83.78,10.55,1,13.86.13,1.61.23,2.87.3,3.77,0,.4.07.73.09,1s.05.33.05.33a1.12,1.12,0,0,0,0-.34c0-.25,0-.57,0-1l-.21-3.77c-.2-3.31-.49-8-.85-13.88-.78-11.74-1.85-27.9-3-45.76-.23-3.38-.46-6.69-.67-9.85l0,.09c4.56-14.88,8.57-28,11.46-37.46,1.41-4.69,2.55-8.47,3.34-11.11.37-1.28.67-2.28.88-3,.08-.33.16-.58.21-.78A.93.93,0,0,0,499.65,319.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.44,160s10.83,13.59,11.42,26.26c.3,6.4-.52,72.92-.52,72.92l1.52,21.17L458,277l2.67-32.69,3.68-37.43a71.17,71.17,0,0,1,12.07-33.2l6.35-9.28Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.44,201.46a2.38,2.38,0,0,1-.47-.28c-.31-.19-.75-.48-1.31-.89a48.8,48.8,0,0,1-4.5-3.66,53.36,53.36,0,0,1-5.84-6.34,50.78,50.78,0,0,1-2.93-4.16,7.58,7.58,0,0,1-1.15-2.51,3,3,0,0,1,0-1.49,2.24,2.24,0,0,1,.94-1.22,3.16,3.16,0,0,1,2.9-.06,6.6,6.6,0,0,1,2.21,1.66,31.44,31.44,0,0,1,3.24,4A45.83,45.83,0,0,1,434.7,194c1,2.24,1.66,4.11,2.11,5.4.23.64.39,1.15.5,1.49a2.13,2.13,0,0,1,.13.54,3.19,3.19,0,0,1-.23-.5l-.59-1.46c-.51-1.27-1.24-3.11-2.26-5.32a47,47,0,0,0-4.2-7.44,31.34,31.34,0,0,0-3.21-3.87,5.93,5.93,0,0,0-2.05-1.54,2.65,2.65,0,0,0-2.42,0,1.76,1.76,0,0,0-.72.93,2.56,2.56,0,0,0,0,1.23,7.24,7.24,0,0,0,1.07,2.35c.93,1.48,1.9,2.86,2.88,4.14a56.14,56.14,0,0,0,5.72,6.36c1.76,1.68,3.29,2.93,4.36,3.77A18.67,18.67,0,0,1,437.44,201.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.55,202a1.89,1.89,0,0,1,.09-.55c.07-.35.19-.87.37-1.53a48.6,48.6,0,0,1,1.84-5.51,52.59,52.59,0,0,1,3.86-7.7q1.26-2.08,2.85-4.22a7.89,7.89,0,0,1,1.95-2,3,3,0,0,1,1.4-.5,2.16,2.16,0,0,1,1.47.45,3.16,3.16,0,0,1,1.08,2.69,6.57,6.57,0,0,1-.77,2.66,32.36,32.36,0,0,1-2.55,4.42,45.17,45.17,0,0,1-5.61,6.55c-1.75,1.72-3.26,3-4.31,3.89-.52.44-.94.77-1.22,1a2.54,2.54,0,0,1-.45.32,2.54,2.54,0,0,1,.38-.4l1.16-1.07c1-.92,2.47-2.25,4.18-4a47.34,47.34,0,0,0,5.47-6.56,31.07,31.07,0,0,0,2.48-4.37,6,6,0,0,0,.72-2.46,2.65,2.65,0,0,0-.87-2.26,1.7,1.7,0,0,0-1.13-.34,2.55,2.55,0,0,0-1.16.42,7.32,7.32,0,0,0-1.81,1.83c-1.06,1.39-2,2.79-2.86,4.16a56.64,56.64,0,0,0-3.92,7.59c-.95,2.25-1.58,4.13-2,5.43S437.59,202,437.55,202Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.79,
    y: 200.75,
    width: 72.64,
    height: 58.91,
    transform: "translate(842.26 494.43) rotate(-175.37)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.96,
    y: 199.85,
    width: 2.11,
    height: 58.91,
    transform: "translate(820.16 491.74) rotate(-175.37)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,200.46c0,.08-7.72,5.2-17.35,11.44s-17.5,11.22-17.56,11.14,7.72-5.21,17.36-11.45S429.92,200.37,430,200.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,199.27c.05.08-3.93,2.75-8.89,6s-9,5.74-9.09,5.66,3.92-2.76,8.89-6S414,199.18,414,199.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.88,201.76c.05.09-11.29,7.76-25.34,17.14S394.06,235.81,394,235.73s11.29-7.76,25.34-17.14S444.82,201.68,444.88,201.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.3,203.18c.05.08-14.9,10.16-33.4,22.51s-33.54,22.3-33.6,22.22,14.9-10.17,33.4-22.52S460.24,203.1,460.3,203.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.27,209c.05.09-16.35,10.84-36.64,24s-36.79,23.8-36.85,23.72,16.35-10.84,36.65-24S469.21,208.94,469.27,209Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.38,220.05c.05.08-12.95,8.63-29.05,19.08S410.14,258,410.08,257.92s12.95-8.63,29.05-19.09S468.32,220,468.38,220.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.4,232.08c.06.08-9.24,6.22-20.76,13.7s-20.9,13.48-21,13.4,9.24-6.22,20.77-13.7S467.35,232,467.4,232.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.4,244.44c.06.09-5.42,3.74-12.23,8.17s-12.38,7.94-12.44,7.86,5.42-3.74,12.24-8.17S466.35,244.36,466.4,244.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 446.25,
    y: 202.83,
    width: 21.1,
    height: 58.91,
    transform: "matrix(-1, -0.08, 0.08, -1, 893.38, 500.65)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 394.75,
    y: 229.34,
    width: 51.22,
    height: 1.8,
    transform: "translate(820.79 493.63) rotate(-175.37)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.88,
    y: 231.86,
    width: 21.51,
    height: 1.81,
    transform: "translate(7.47 -14.11) rotate(1.79)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.6,
    y: 202.88,
    width: 1.85,
    height: 58.91,
    transform: "translate(894.82 500.85) rotate(-175.37)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.81,260.26a2.7,2.7,0,0,1,0-.5c0-.35.05-.83.09-1.42.09-1.28.21-3.08.37-5.31.35-4.55.84-10.86,1.4-18.07l.36,0c-.06.66-.11,1.37-.17,2.09l-.36,0c.1-1.29.21-2.66.32-4,.73-8.66,1.38-16.5,1.86-22.22.25-2.81.45-5.1.6-6.72.07-.77.14-1.38.18-1.83q0-.28.06-.48c0-.1,0-.16,0-.16a.74.74,0,0,1,0,.17c0,.13,0,.28,0,.47,0,.45-.06,1.07-.11,1.84-.12,1.62-.28,3.91-.49,6.73-.45,5.72-1.06,13.56-1.74,22.23-.11,1.38-.23,2.74-.33,4l-.36,0c.06-.72.12-1.43.17-2.09l.36,0c-.61,7.2-1.14,13.51-1.53,18.06-.2,2.23-.36,4-.48,5.3l-.15,1.42A2.46,2.46,0,0,1,443.81,260.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "484.57 235.76 484.34 219.45 480.7 218.63 482.61 197.8 483.57 214.84 487.74 214.67 487.81 235.7 484.57 235.76"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M451.29,236.18s-4.73-5-6.49-6-7.89-3.29-9.83-5.3a1.67,1.67,0,0,0-.82,2.76,18.89,18.89,0,0,0,5.64,5.17c1.52.77.81,1.83-.42,2s-9.69.09-9.69.09-9.57-1.54-10.53-.71a1.71,1.71,0,0,0,.19,2.66c.52.3,8.61,2.34,8.61,2.34l4.3.27s-13.52,0-14.47,1a1.47,1.47,0,0,0,.16,2.36c.6.52,6.57.45,6.57.45l8,.46-15,1.48s-1.4.32-1.33,1.45,1.81,1.68,1.81,1.68l15.65-.17s-8.31,3.83-8.69,4.46c-.52.84.86,2,1.51,1.68s10.89-2.6,10.89-2.6l11.75-3,7.16,1.4-.68-13.88Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.41,255.18l-30.75-6.09,2.94-12.74,34.21-.65-.32-25.11,23.43-1.09a231.19,231.19,0,0,1-1.16,35.85s-.24,10-11.73,10.69A102.16,102.16,0,0,1,481.41,255.18Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.86,213.57l-32.29,1.27s-1.73-21.2-.89-26.84,11.76-21.95,21.92-16.39c0,0,3.4-.06,5.58,4.86C511.06,178.45,515.86,213.57,515.86,213.57Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.57,185.34a17,17,0,0,1,1.16-4.44,20.58,20.58,0,0,1,2.51-4.29,11.88,11.88,0,0,1,4.47-4,13.11,13.11,0,0,1,5.88-1.16,26.3,26.3,0,0,1,4.94.66,18.59,18.59,0,0,1,3.21,1c.73.31,1.1.55,1.13.52s-.08-.09-.25-.21a6.12,6.12,0,0,0-.8-.48,16.2,16.2,0,0,0-3.2-1.18,24.13,24.13,0,0,0-5-.77,13.33,13.33,0,0,0-6.11,1.16,11.92,11.92,0,0,0-4.61,4.16,19.49,19.49,0,0,0-2.48,4.42,13,13,0,0,0-.83,3.32,7,7,0,0,0-.05.93C484.54,185.23,484.55,185.34,484.57,185.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.73,195.39s0,.13,0,.38,0,.65,0,1.09c0,1,.06,2.38.11,4.06.13,3.53.31,8.37.52,13.93v.23h.24l6.42-.24,18.29-.79,5.54-.29,1.5-.11a2,2,0,0,0,.53-.07,3.17,3.17,0,0,0-.53,0h-1.51l-5.55.14-18.29.64-6.42.26.24.23c-.27-5.56-.51-10.4-.68-13.92-.1-1.68-.19-3-.25-4.06,0-.43-.06-.79-.08-1.09A1.93,1.93,0,0,0,482.73,195.39Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.27,265.59a22.29,22.29,0,0,0-9,1.77,16.25,16.25,0,0,1-8,1.72c-1.4.06-3.77-.1-3.83,1.11s1.47,1.9,4.09,2.62,5.56-.09,6,1.16-6.84,10.67-9.24,13.24-3,4.1-1.24,4.55,7.67-8.48,9.45-8.3.87,1,.62,2.25-7.33,10.45-5.65,11.75,2.54.05,2.54.05,2,1.58,3.57.35,6.47-12,7.54-10.87-3,9.19-1.13,10.61,2.25-1,3-3.22A61.63,61.63,0,0,1,271.38,284c2-3.38,5-8.63,5-8.63Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.22,297.83a71.57,71.57,0,0,0,4-6.74,68,68,0,0,0,3.57-6.95,68.52,68.52,0,0,0-4,6.74A70.54,70.54,0,0,0,254.22,297.83Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.66,276.57s17.48-19.12,16.49-19.93-14-6.63-14-6.63l-10.6,16.76Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.67 460.11 351.54 450.6 334.77 449.56 334.73 461.19 340.74 464.97 351.67 460.11",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.41,459l0,1.09s-18.83,7.12-19.08,10.62l37.16.38-.38-12.19A21.5,21.5,0,0,1,334.41,459Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.29,462.77a1.5,1.5,0,0,1,1,1.72,1.47,1.47,0,0,1-1.72,1,1.58,1.58,0,0,1-1.08-1.83,1.5,1.5,0,0,1,1.9-.86",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.47,471.1l-.09-2.93-35.58.7s-1.66.7-1.49,1.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.26,460.2c0,.18.91.27,1.8.86s1.35,1.34,1.52,1.27-.09-1.11-1.18-1.79S334.22,460,334.26,460.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.35,461.75c-.05.18.74.49,1.35,1.25s.77,1.57.95,1.56.31-1-.46-1.95S330.35,461.58,330.35,461.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.09,466.33c.16,0,.42-.85,0-1.84s-1.3-1.38-1.38-1.23.44.67.8,1.49S327.91,466.31,328.09,466.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.59 460.11 368.46 450.6 351.69 449.56 351.65 461.19 357.66 464.97 368.59 460.11",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.34,459l0,1.09s-18.82,7.12-19.08,10.62l37.16.38L369,458.91A21.48,21.48,0,0,1,351.34,459Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.21,462.77a1.5,1.5,0,0,1,1,1.72,1.47,1.47,0,0,1-1.72,1,1.58,1.58,0,0,1-1.08-1.83,1.5,1.5,0,0,1,1.9-.86",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.39,471.1l-.09-2.93-35.58.7s-1.66.7-1.49,1.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M351.18,460.2c0,.18.91.27,1.8.86s1.35,1.34,1.52,1.27-.09-1.11-1.18-1.79S351.15,460,351.18,460.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.27,461.75c0,.18.74.49,1.35,1.25s.77,1.57.95,1.56.31-1-.46-1.95S347.27,461.58,347.27,461.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,466.33c.16,0,.42-.85,0-1.84s-1.3-1.38-1.38-1.23.44.67.8,1.49S344.83,466.31,345,466.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.49,266.2s-6.93,10.71-8,29.31,14.31,75.67,16.43,87.88c1.44,8.3,8.43,49,17,74.24h14s-9.29-83.37-8.93-92.14,3.56-55.43,3.56-55.43l5.37-41.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.26,266.2c-1.06.35-33.35,1.34-33.35,1.34s-12.7,101.4-13.76,114,17.19,77.34,17.19,77.34l18-.44S365,416,362.12,403s-2.85-16.14-1.07-24.21,18.43-46.79,23.06-68.2S377.26,266.2,377.26,266.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.66,298.29a3.35,3.35,0,0,1,0,.42c0,.29-.09.7-.16,1.23-.16,1.09-.39,2.68-.69,4.7L339.16,322,330.42,379a43.16,43.16,0,0,0,.34,8.28c.31,2.72.72,5.39,1.18,8,.91,5.23,2,10.25,3,15,2.14,9.54,4.3,18.07,6.17,25.23s3.44,12.92,4.54,16.91c.54,2,1,3.52,1.26,4.59l.33,1.2c.07.27.09.41.09.41s-.06-.14-.14-.4-.21-.68-.37-1.18c-.31-1.07-.77-2.61-1.35-4.57-1.15-4-2.78-9.74-4.69-16.88s-4.11-15.68-6.27-25.22c-1.07-4.77-2.13-9.79-3-15-.46-2.62-.87-5.3-1.19-8A43.17,43.17,0,0,1,330,379c3.36-22.32,6.59-42.47,8.88-57.08,1.16-7.28,2.1-13.18,2.76-17.28l.77-4.7.21-1.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,286.24a33.14,33.14,0,0,1-3.47,1c-2.15.6-5.09,1.5-8.28,2.69s-6,2.46-8,3.42A34.22,34.22,0,0,1,342,294.9s.27-.23.8-.56,1.32-.78,2.3-1.3a69.7,69.7,0,0,1,8-3.58,70.85,70.85,0,0,1,8.37-2.57c1.09-.25,2-.44,2.6-.54A3.53,3.53,0,0,1,365,286.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.29,137.74c-4-15-7.67-32.42-29.9-30.86,0,0-13.7,2.6-20.2,12.57-3.83,5.86-1.71,33.66-7.8,51.08h0c0,.81-3.3,19.81-1.72,29.81l60.85-17.71h10.6a101.75,101.75,0,0,0-3.86-20.86C367.15,151.8,363.7,143,362.29,137.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.43,113.55l1.4-1.3,15,6a4.14,4.14,0,0,1,4,4l-.13,48.26A13.41,13.41,0,0,1,347,179.2l-2.11,2.74c-4.81,6.27-14.71,5.75-18.52-1.15a4.92,4.92,0,0,1-.53-1.25c-.08-.43-.2-.71-.23-1.08-.44-3.88-.47-7.25-.47-7.25-.27-4.26-.35-6-.35-6s-9.21-1-11.7-12.69c-1.23-5.79-1-13.76-.65-21.6C313,120.1,320.59,113.54,329.43,113.55Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.53,139.31a1.52,1.52,0,0,0,1.55,1.44,1.44,1.44,0,0,0,1.5-1.43,1.51,1.51,0,0,0-1.54-1.45A1.46,1.46,0,0,0,332.53,139.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.37,140a1.53,1.53,0,0,0,1.55,1.45,1.45,1.45,0,0,0,1.5-1.44,1.52,1.52,0,0,0-1.54-1.45A1.46,1.46,0,0,0,317.37,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,134.05c.2.19,1.31-.71,3-.79s2.89.68,3.05.47-.12-.44-.67-.79a4.27,4.27,0,0,0-2.46-.62,4.07,4.07,0,0,0-2.34.88C314.09,133.61,313.94,134,314,134.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.34,133.5c.22.17,1.23-.84,2.86-1.08s2.94.37,3.09.15-.17-.42-.75-.72a4.27,4.27,0,0,0-2.51-.36,4.07,4.07,0,0,0-2.24,1.11C330.35,133.05,330.23,133.43,330.34,133.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,146a11.59,11.59,0,0,0-2.7-.34c-.42,0-.82-.08-.91-.36a2.1,2.1,0,0,1,.22-1.24c.35-1,.7-2.09,1.08-3.21,1.5-4.57,2.56-8.32,2.37-8.38s-1.55,3.6-3.05,8.17c-.35,1.13-.7,2.2-1,3.23a2.35,2.35,0,0,0-.14,1.63,1.07,1.07,0,0,0,.72.57,2.72,2.72,0,0,0,.72.06A10.3,10.3,0,0,0,325,146Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.82,165.24a30.59,30.59,0,0,0,15.73-5s-3.6,8.32-15.57,7.82Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.11,149.31a2.73,2.73,0,0,0-1.92-.9,2.28,2.28,0,0,0-2.31.87,1.64,1.64,0,0,0-.11,1.31c.12.19,0,.19.21.32a6.16,6.16,0,0,0,2.23,1,2,2,0,0,0,2.13-.65A1.66,1.66,0,0,0,330.11,149.31Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,128.14c.12.45,1.59.33,3.3.65s3.07.92,3.32.54c.11-.19-.11-.61-.64-1.07a5.29,5.29,0,0,0-2.42-1.1,5.11,5.11,0,0,0-2.63.2C331.3,127.6,331,127.93,331,128.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.23,129.59c.29.37,1.43,0,2.79,0s2.52.25,2.78-.14c.12-.19-.06-.55-.57-.9a4.06,4.06,0,0,0-4.48.13C314.26,129,314.11,129.41,314.23,129.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.51,142.82s-6.32,1.5-15.3-17.55c-3-6.49-9-13-9-13l5.57-.8s16.6,4.61,16.88,4.82,4.19,8.46,4.19,8.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.44,142.05c0-.87.88-3,1.75-3.16,2.32-.48,6.54-.5,6.88,5.35.46,8-7.79,6.81-7.81,6.58S347.59,145.07,347.44,142.05Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.56,147.65s.15.09.39.19a1.45,1.45,0,0,0,1.06,0c.84-.36,1.49-1.74,1.44-3.19a4.45,4.45,0,0,0-.51-2,1.63,1.63,0,0,0-1.12-1,.72.72,0,0,0-.81.43c-.1.23,0,.39-.08.4s-.18-.12-.14-.46a1,1,0,0,1,.29-.52,1.1,1.1,0,0,1,.77-.24,2,2,0,0,1,1.55,1.15,4.67,4.67,0,0,1,.62,2.21c0,1.61-.71,3.17-1.86,3.57a1.56,1.56,0,0,1-1.31-.14C350.59,147.85,350.54,147.67,350.56,147.65Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.44,151.58c0,.12.44.27,1.19.2a4.84,4.84,0,0,0,4.17-3.6c.16-.73.07-1.18-.05-1.19s-.58,1.66-2.08,2.95S324.43,151.33,324.44,151.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.06,151.68a2.43,2.43,0,1,0,2.43-2.39A2.41,2.41,0,0,0,347.06,151.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.79,190.76,373,224.9,363.86,234s7.72,14,10.58,15.83,7.15,2.11,12.29,0,4.86-8.6,5-13.11-9.87-45.38-11-48.48-5-7.75-11.73-9.87Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.05,177.94l-12.28-2.55-7.51-3.18s-3.39,4.69-11.43,5.74a14.53,14.53,0,0,1-12.52-4.1L323.49,176l-15.6,5.44,3.42,25a42.83,42.83,0,0,0-.23,16.33c1.68,8.16,3.52,14.84,3.52,14.84l-8.31,32.43,73.86.41-10.73-33.33,1.91-36.28Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.61,215.36c7.35,6.84,11.63,16.19,15.74,25.3l1.54,7.24c-3.68-.64-7.57-2.57-9.39-5.79a29.37,29.37,0,0,1-2.45-7.25,45.31,45.31,0,0,0-4.6-11.72,25.69,25.69,0,0,0-8.66-9.1c-2.58-1.55-5.46-2.55-8.05-4.08s-5-3.78-5.59-6.7C340.88,206.22,348.58,209.75,354.61,215.36Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M388.74,233.77a7.14,7.14,0,0,0-2.28-4.73,7.35,7.35,0,0,0-5-1.9l-3.59-4.3L363.46,235c-.47,6,4.19,9.51,10.85,14.91",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.31,249.86s-.08-.1-.26-.26-.49-.42-.81-.7c-.76-.64-1.79-1.51-3.06-2.6a30.67,30.67,0,0,1-4.26-4.32,11.66,11.66,0,0,1-1.76-3.14,9.21,9.21,0,0,1-.49-3.87l-.08.14,6.13-5.12,8.32-7-.29,0,3.62,4.28.05.07h.08a7.26,7.26,0,0,1,4.15,1.25,6.92,6.92,0,0,1,2.21,2.46,8.56,8.56,0,0,1,.88,2.74s0-.06,0-.19a5.49,5.49,0,0,0-.05-.57,7.1,7.1,0,0,0-2.89-4.67A7.5,7.5,0,0,0,381.5,227l.14.06-3.58-4.32-.13-.15-.15.13-8.34,7-6.12,5.13-.06.06v.09a9.62,9.62,0,0,0,.53,4,11.72,11.72,0,0,0,1.86,3.23,29.58,29.58,0,0,0,4.37,4.3c1.32,1.1,2.4,1.93,3.14,2.51.34.26.63.47.85.65A1.5,1.5,0,0,0,374.31,249.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.17,181.48c-1.41.59-5.93,2.88-9.13,10.06-1.6,3.59-5.16,18.21-9.68,32.56a118.43,118.43,0,0,1-15,29.93l18.09,4,12.94-16.54,12.11-32.48Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.46,214.61a3.42,3.42,0,0,0,0,.87,12.8,12.8,0,0,0,.43,2.31,15.64,15.64,0,0,0,3.86,6.72,16.06,16.06,0,0,0,6.66,4.07,13.73,13.73,0,0,0,2.32.52,3.45,3.45,0,0,0,.88.05c0-.08-1.23-.21-3.1-.86a16.89,16.89,0,0,1-6.45-4.08,16.56,16.56,0,0,1-3.87-6.51C341.62,215.83,341.55,214.6,341.46,214.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.57,238.94a2.23,2.23,0,0,0,.7-.16,16.34,16.34,0,0,0,1.81-.65,22.8,22.8,0,0,0,5.43-3.29,22.27,22.27,0,0,0,4.28-4.67,14.71,14.71,0,0,0,1-1.64c.21-.4.31-.63.28-.64s-.56.83-1.52,2.11a26,26,0,0,1-4.3,4.5,26.4,26.4,0,0,1-5.28,3.35C368.5,238.54,367.55,238.87,367.57,238.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.78,193.4a3.34,3.34,0,0,0-.17.86c-.08.55-.18,1.36-.29,2.35-.22,2-.47,4.74-.67,7.79s-.31,5.81-.35,7.81c0,1,0,1.81,0,2.37a3.36,3.36,0,0,0,.06.87,3.3,3.3,0,0,0,.11-.87c.05-.65.1-1.44.16-2.36.13-2.1.3-4.8.48-7.79s.4-5.69.54-7.79l.15-2.36A3.37,3.37,0,0,0,372.78,193.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.57,187.3c1-11.07-2-12.21-2.82-19.2l-20.51-4.8a178.89,178.89,0,0,1-5.76,38.6,51.6,51.6,0,0,0,21.06,2.16q.48-5.06.94-10.13l1.38,7.64s2,.38,4-5.08A40.47,40.47,0,0,0,373.57,187.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.82,204.32s-3.34-7.88-4.82-9.6c-1.72-2-10.49-7.07-10.49-7.07s-1.28,2,0,3.27c0,0-8.5-4.12-10.62-4.12s-1.48,2.11-1.48,2.11-2.56-1.43-3.31,0,1.14,2.82,1.14,2.82L341.8,198s-9.12-4.33-10.25-4.74c-1.8-.65-2.86,1.68-.91,2.84s11,5.52,10.84,6.65-1.71.42-2,.21-6.46-3.62-7.5-3.17c-1.27.56-.63,1.8.11,2.12s15.25,9.21,16.91,9.8,4.88,2,5.95,3.62S364,234.37,364,234.37l12.65-10.47Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.23,188.9c0,.11,2.29,1.09,5,2.63a44.16,44.16,0,0,0,5,2.65,6.68,6.68,0,0,0-1.35-1c-.86-.55-2.07-1.29-3.44-2A19.31,19.31,0,0,0,334.23,188.9Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.23,196.42a4.93,4.93,0,0,0-1.09-1.2,19.2,19.2,0,0,0-3.14-2.33,23.25,23.25,0,0,0-3.51-1.73,5.67,5.67,0,0,0-1.56-.46c-.06.13,2.26,1,4.84,2.56S355.13,196.52,355.23,196.42Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.92,194.65a1.17,1.17,0,0,1,.07-.25c.07-.19.16-.43.26-.72.24-.62.58-1.54,1-2.73a102.53,102.53,0,0,0,3-10.27A96.21,96.21,0,0,0,363.64,165a90.14,90.14,0,0,0,.15-9.36,42.11,42.11,0,0,0-1.43-9.89A23.12,23.12,0,0,0,357.8,137a34.13,34.13,0,0,0-7-6.07c-5-3.3-9.82-5.73-13.44-8.52a27.36,27.36,0,0,1-7.37-7.76,14.24,14.24,0,0,1-1.57-3.61,1.09,1.09,0,0,1,.12.23c.07.19.17.42.29.7a19,19,0,0,0,1.33,2.57,28.05,28.05,0,0,0,7.42,7.58c3.61,2.72,8.46,5.11,13.49,8.41a34.11,34.11,0,0,1,7.15,6.14,23.39,23.39,0,0,1,4.67,9,41.94,41.94,0,0,1,1.44,10,88.08,88.08,0,0,1-.18,9.41,94.64,94.64,0,0,1-2.49,15.73A91.44,91.44,0,0,1,358.44,191c-.45,1.18-.82,2.09-1.09,2.7l-.31.7A1.09,1.09,0,0,1,356.92,194.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.08,206c.09,0-.48,1.42-1.08,3.75a33.77,33.77,0,0,0,.45,18.52c.71,2.29,1.35,3.65,1.27,3.69a4.13,4.13,0,0,1-.52-.92,23.78,23.78,0,0,1-1.1-2.66,30.78,30.78,0,0,1-.46-18.73,22.68,22.68,0,0,1,1-2.71A4.5,4.5,0,0,1,313.08,206Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.45,211.5a62.06,62.06,0,0,0-49.9-18.35c5.51,21,14.9,40,31,54.65A63.6,63.6,0,0,0,150.77,259a33.88,33.88,0,0,0,19.32,3A62,62,0,0,0,153.45,211.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.33,260.92l-.21-.11-.62-.37c-.53-.34-1.33-.81-2.31-1.49a94.66,94.66,0,0,1-8.08-6.11,138.19,138.19,0,0,1-10.92-10.31c-3.92-4.08-8-8.76-12.2-13.76l-11.72-14.15c-3.63-4.32-7-8.14-9.9-11.26s-5.36-5.55-7.09-7.19c-.86-.84-1.55-1.45-2-1.89l-.51-.5c-.12-.12-.17-.18-.16-.19l.19.15.55.45c.48.42,1.2,1,2.07,1.82,1.78,1.6,4.28,4,7.24,7.08s6.35,6.89,10,11.2,7.58,9.12,11.76,14.12,8.25,9.68,12.14,13.77a143.93,143.93,0,0,0,10.81,10.36c3.24,2.77,6,4.86,7.94,6.23,1,.71,1.74,1.21,2.25,1.58l.59.41C169.28,260.86,169.34,260.91,169.33,260.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.67,262.28a1,1,0,0,1-.25,0l-.73.05a27.31,27.31,0,0,1-2.84.08A41.39,41.39,0,0,1,156.53,261a53.48,53.48,0,0,1-14.13-6.29,66.36,66.36,0,0,1-14.4-12.3,94.5,94.5,0,0,1-10.94-15.47A124.71,124.71,0,0,1,110.21,213c-1.72-4.05-2.93-7.41-3.7-9.75-.4-1.16-.66-2.08-.86-2.7-.08-.28-.15-.52-.2-.71s-.06-.24,0-.24,0,.07.1.22.16.42.26.7l.95,2.66c.84,2.31,2.1,5.64,3.86,9.67a131.5,131.5,0,0,0,6.93,13.77A95.68,95.68,0,0,0,128.42,242a67,67,0,0,0,14.25,12.24,54.11,54.11,0,0,0,14,6.34,43.17,43.17,0,0,0,10.23,1.64c1.22.1,2.18,0,2.82,0h.74A.67.67,0,0,1,170.67,262.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,191a13.72,13.72,0,0,0-6.53-11.18l13.19,38.09a8.61,8.61,0,0,0,2.8-13.86c.65-3.24.63-6.79-1-9.64S183.9,189.72,180.85,191Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.65,185.88c-.86-5.15-5.72-9.06-10.9-9.74s-10.42,1.42-14.47,4.71c-3.19,2.59-5.92,6.45-5.3,10.51-3.32.14-7.6,3.23-9.2,6.15a9.89,9.89,0,0,0,.15,9.54,12.91,12.91,0,0,0,5.23,21.52c-1.1,5.52,4.29,12,9.51,14.06s9.87.42,15.18-1.43c7.27-2.52,14-7.15,17.88-13.82A25.36,25.36,0,0,0,182.88,197a15.41,15.41,0,0,1-3.23-3.86C178.6,190.93,179.05,188.31,178.65,185.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.94,254.58a12.69,12.69,0,0,1-17.55-2.67l-25-33.18c-7-8.7-7.76-20,1.13-26.77l.85-.57a20,20,0,0,1,26.75,4.14c6,7.58,12.57,16,15.4,20.36,5.86,9-2.11,16.32-2.11,16.32s1.45,2,3.31,4.55a12.68,12.68,0,0,1-2.81,17.82Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.44,232.21a25,25,0,0,1-13.8,4.45s7.28,4.82,15.62-1.93Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.14,220.59c.89-.22,1.92-.6,2.45.15s1.14,2.84.64,3.62a4.27,4.27,0,0,1-1.94,1.14,2.77,2.77,0,0,1-1.56-.23,2.3,2.3,0,0,1-1.61-1.33,9.77,9.77,0,0,1-.47-2.9",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.13,207.6a1.53,1.53,0,0,1-.37,2.1,1.47,1.47,0,0,1-2.08-.27,1.53,1.53,0,0,1,.37-2.1A1.46,1.46,0,0,1,182.13,207.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.21,201.17c0,.27-1.48.2-2.85,1.12s-1.91,2.28-2.17,2.21-.16-.43.07-1a4.09,4.09,0,0,1,1.59-2,4,4,0,0,1,2.41-.69C178.9,200.84,179.24,201,179.21,201.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.15,215.1a1.53,1.53,0,0,1-.37,2.1,1.46,1.46,0,0,1-2.08-.27,1.53,1.53,0,0,1,.37-2.1A1.46,1.46,0,0,1,169.15,215.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.29,210.32c0,.27-1.49.2-2.86,1.12s-1.9,2.28-2.16,2.21-.17-.43.06-1a4.12,4.12,0,0,1,1.6-2,4,4,0,0,1,2.4-.69C166,210,166.31,210.19,166.29,210.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.74,217.35a10.88,10.88,0,0,1,1.95-1.89c.32-.27.61-.56.5-.84s-.48-.58-.92-.87l-2.82-2c-4-2.82-7.1-5.23-7-5.39s3.43,2,7.4,4.82l2.78,2a2.37,2.37,0,0,1,1.1,1.24,1.07,1.07,0,0,1-.23.9,2.87,2.87,0,0,1-.54.48A10.68,10.68,0,0,1,177.74,217.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.6,203.94c.09.47-1.44,1.12-3,2.3s-2.63,2.42-3.06,2.21c-.19-.11-.17-.61.15-1.3a6.6,6.6,0,0,1,4.6-3.44C162.07,203.6,162.55,203.72,162.6,203.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.34,198.17c-.12.46-1.32.53-2.59,1s-2.23,1.18-2.63.92c-.18-.13-.15-.55.18-1.07a3.91,3.91,0,0,1,1.87-1.42,3.87,3.87,0,0,1,2.34-.15C175.1,197.66,175.39,198,175.34,198.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.64,224.94c-.2,0-7.32,2.29-3,8.24s9.37.43,9.25.25S154.64,224.94,154.64,224.94Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.41,232.48s0,.15-.17.36a1.31,1.31,0,0,1-.76.57,3.15,3.15,0,0,1-2.84-1.45,4.1,4.1,0,0,1-.78-1.69,1.48,1.48,0,0,1,.21-1.36.63.63,0,0,1,.81-.15c.2.11.25.25.29.24s.05-.19-.17-.4a.86.86,0,0,0-.5-.21,1,1,0,0,0-.68.26,1.77,1.77,0,0,0-.42,1.7,4.27,4.27,0,0,0,.83,1.92c.9,1.17,2.32,1.85,3.36,1.48a1.38,1.38,0,0,0,.83-.84C157.5,232.63,157.44,232.48,157.41,232.48Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,226.08c0,.06-.17.15-.47.15a1.56,1.56,0,0,1-1.06-.51,1.54,1.54,0,0,1-.38-1.11c0-.31.14-.46.2-.45s0,.71.52,1.26S174,226,174,226.08Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.57,217.7c.09.08-.27.61-1,.94s-1.33.29-1.34.17.53-.28,1.14-.58S164.48,217.61,164.57,217.7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.24,218c.07.11-.3.44-.63.93s-.52.94-.65.91-.11-.6.28-1.17S165.19,217.91,165.24,218Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.79,205.26c.12,0,.13.51-.23,1s-.84.58-.88.46.25-.36.53-.73S184.67,205.23,184.79,205.26Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.57,206.46c.07.1-.23.42-.72.65s-.92.26-1,.14.32-.33.77-.55S185.5,206.35,185.57,206.46Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.51,227c0,.12-.55.24-1.1-.14s-.63-1-.51-1,.34.33.76.62S173.51,226.87,173.51,227Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.24,245.82a2.83,2.83,0,0,0-.67-1.48,2,2,0,0,0-.67-.45,3.51,3.51,0,0,0-.94-.17,1.76,1.76,0,0,1-1.14-.47,1.67,1.67,0,0,1-.33-1.28,2,2,0,0,0-.14-1.05,1.17,1.17,0,0,0-.79-.45c-.33-.08-.68-.12-1-.23a1.44,1.44,0,0,1-.8-.55,1.71,1.71,0,0,1-.13-1.33c.07-.3.15-.45.18-.45s0,.18,0,.47a1.75,1.75,0,0,0,.22,1.13c.28.38.9.43,1.63.55a1.54,1.54,0,0,1,1.07.63,2.14,2.14,0,0,1,.21,1.29,1.41,1.41,0,0,0,.21,1,1.5,1.5,0,0,0,.88.35,3.68,3.68,0,0,1,1,.24,2,2,0,0,1,.75.57,2.13,2.13,0,0,1,.51,1.23C177.33,245.66,177.26,245.83,177.24,245.82Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.61,244c-.08,0-.18-.53-.91-1-.34-.24-.8-.46-1.29-.78a2.68,2.68,0,0,1-.72-.64,1.84,1.84,0,0,1-.35-1,1.1,1.1,0,0,0-.21-.75,1.33,1.33,0,0,0-.7-.25,4.68,4.68,0,0,1-.83-.16A1.43,1.43,0,0,1,174,239a1.46,1.46,0,0,1-.29-1.05c.05-.25.15-.37.17-.36s0,.15,0,.37a1.37,1.37,0,0,0,.36.84c.25.31.69.37,1.28.41a1.67,1.67,0,0,1,1,.34,1.46,1.46,0,0,1,.36,1,1.69,1.69,0,0,0,.85,1.34c.45.32.9.58,1.25.86a2,2,0,0,1,.66.84C179.64,243.89,179.63,244,179.61,244Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.52,217.59c.06.11-.51.55-1.14,1.15s-1.12,1.13-1.23,1.06.24-.76.92-1.39S170.46,217.48,170.52,217.59Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.13,190a13.47,13.47,0,0,0-10.48-3.34c-3.76.31-9.07.85-12.32,2.78a28.57,28.57,0,0,0-8.66,8.44c-2.49,4-2.5,9.64-1.59,14.22s5,7.91,7.88,11.57l3.15,3.29c1.18,1,3.2.2,3.9-1.21a7.45,7.45,0,0,0,.16-4.63c-1.36-7.17-3.55-14.33-7.83-20.24a38.65,38.65,0,0,0,12.36-1,5.8,5.8,0,0,0,2.64-1.2,2.21,2.21,0,0,0,.56-2.65,18.56,18.56,0,0,0,7.4,1.33c1.57,0,3.33-.38,4.22-1.68a3.58,3.58,0,0,0,.35-3.06A6.42,6.42,0,0,0,176.13,190Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.44,224.35c-.05-.08,1.39-.7,3.34-2.23a19.89,19.89,0,0,0,3.09-3,24.09,24.09,0,0,0,2.86-4.48,22.48,22.48,0,0,0,2.28-9.31c.06-2.48-.26-4-.18-4a4.17,4.17,0,0,1,.25,1.06,18.53,18.53,0,0,1,.24,3,21.23,21.23,0,0,1-2.19,9.51,22.77,22.77,0,0,1-2.94,4.54,18.87,18.87,0,0,1-3.22,3,17.37,17.37,0,0,1-2.53,1.56A4.7,4.7,0,0,1,138.44,224.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.53,195.53s.23-.15.59-.48a3.67,3.67,0,0,0,1-1.79,3.23,3.23,0,0,0-.68-3,3.51,3.51,0,0,0-3.74-1l-.25.1,0-.26a8.43,8.43,0,0,0-5.61-6.81,10.79,10.79,0,0,0-7.5.3,13.89,13.89,0,0,0-5.1,3.61,19.67,19.67,0,0,0-2.51,3.46c-.51.87-.76,1.38-.79,1.37a1.53,1.53,0,0,1,.13-.39c.11-.25.27-.61.5-1.07a18.2,18.2,0,0,1,2.43-3.58,13.87,13.87,0,0,1,5.19-3.78,11,11,0,0,1,7.8-.34,8.78,8.78,0,0,1,5.85,7.19l-.26-.16a3.82,3.82,0,0,1,4.12,1.1,3.41,3.41,0,0,1,.66,3.26,3.58,3.58,0,0,1-1.18,1.82,2.79,2.79,0,0,1-.49.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.83,224.09s-.1.19-.38.45a5,5,0,0,1-1.33.89,3.64,3.64,0,0,1-2.39.27,2.7,2.7,0,0,1-1.31-.69,3.18,3.18,0,0,1-.82-1.35,7.53,7.53,0,0,1-.29-1.49c0-.25-.05-.46,0-.74a.86.86,0,0,1,.12-.44.7.7,0,0,1,.38-.29,12.64,12.64,0,0,1,2.33-.44,5.32,5.32,0,0,1,2.15.05,20.42,20.42,0,0,1-2.11.31,18.47,18.47,0,0,0-2.2.52c-.15.07-.16.11-.18.31s0,.44.06.66a8.32,8.32,0,0,0,.27,1.39,2.47,2.47,0,0,0,1.75,1.74,3.53,3.53,0,0,0,2.14-.15C180.17,224.62,180.77,224,180.83,224.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.48,
    cy: 470.57,
    r: 13.51,
    transform: "translate(-73.03 39.02) rotate(-9.26)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.38,465.42l.23-24.84H188.48L188.25,462a5.38,5.38,0,0,0,5.38,5.38h2a9.32,9.32,0,0,0-.52,4.07,9.58,9.58,0,0,0,9.55,8.53,9.43,9.43,0,0,0,7.75-14.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.41,470.57a3.93,3.93,0,1,1-3.93-3.93A3.94,3.94,0,0,1,208.41,470.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.41,380.35h0a8.18,8.18,0,0,1-8.18-8.24l.79-113A8.18,8.18,0,0,1,525.2,251h0a8.19,8.19,0,0,1,8.19,8.24l-.79,113A8.19,8.19,0,0,1,524.41,380.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.41,380.35a9.37,9.37,0,0,0,2.74-.54A8.26,8.26,0,0,0,530,378a8,8,0,0,0,2.25-3.95,10.42,10.42,0,0,0,.23-2.73c0-1,0-2,0-3.06q0-3.21,0-6.95c0-5,.05-10.66.07-16.93.08-12.56.16-27.5.25-44.09.06-8.29.11-17,.17-26q0-6.76.09-13.77a11.63,11.63,0,0,0-.27-3.4,7.79,7.79,0,0,0-1.57-3,7.9,7.9,0,0,0-12.11,0,7.86,7.86,0,0,0-1.57,3,12.39,12.39,0,0,0-.3,3.41c0,4.66-.06,9.26-.1,13.77-.07,9-.13,17.74-.2,26-.13,16.59-.26,31.53-.36,44.08-.06,6.27-.12,12-.16,16.94,0,2.49-.05,4.81-.08,6.94q0,1.61,0,3.06a10.13,10.13,0,0,0,.22,2.74,8.13,8.13,0,0,0,5.1,5.73,9.42,9.42,0,0,0,2.74.54s-.24,0-.72,0a7.59,7.59,0,0,1-2.06-.43,8.26,8.26,0,0,1-2.92-1.77,8.41,8.41,0,0,1-2.35-4,10.15,10.15,0,0,1-.25-2.79c0-1,0-2,0-3.06q0-3.21,0-6.95c0-5,0-10.66.07-16.93.07-12.56.16-27.5.25-44.09.06-8.29.11-17,.17-26q0-6.78.09-13.77a13.12,13.12,0,0,1,.32-3.56,8.39,8.39,0,0,1,1.68-3.21,8.44,8.44,0,0,1,12.95,0,8.26,8.26,0,0,1,1.68,3.21,12.32,12.32,0,0,1,.3,3.56q-.06,7-.11,13.77c-.06,9-.13,17.73-.19,26-.14,16.58-.27,31.52-.37,44.08-.06,6.27-.11,12-.16,16.93q0,3.74-.07,6.95c0,1.07,0,2.09,0,3.06a10.9,10.9,0,0,1-.26,2.78,8.21,8.21,0,0,1-5.27,5.79,7.59,7.59,0,0,1-2.06.43C524.65,380.36,524.41,380.35,524.41,380.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.03,
    y: 346.67,
    width: 13.23,
    height: 37.59,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.12,
    y: 426.91,
    width: 350.54,
    height: 11.47,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.66,438.38s0-.92,0-2.81,0-4.75,0-8.66l.06.07-350.52.21h0l.28-.28v11.47l-.28-.28,248.22.12,74.87.08,20.34,0,5.3,0,1.81,0-1.77,0-5.26,0-20.27,0-74.82.08-248.42.12h-.28v-12h.3l350.52.22h.07v.06c0,3.93,0,6.8,0,8.7S484.66,438.38,484.66,438.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 386.31,
    width: 11.95,
    height: 38.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,424.73a4.53,4.53,0,0,1,0-.78c0-.54,0-1.27,0-2.18,0-1.93,0-4.66-.08-8.06,0-6.87-.07-16.42-.12-27.4l.27.27H185c.55-.55.15-.15.28-.27h0V392c0,1.88,0,3.73,0,5.54,0,3.62,0,7.08,0,10.35,0,6.52-.05,12.25-.07,16.8l-.18-.18,8.74.1,2.36,0,.85,0s-.26,0-.78,0l-2.32,0-8.85.1h-.18v-.18c0-4.55,0-10.28-.07-16.8,0-3.27,0-6.73,0-10.35,0-1.81,0-3.66,0-5.54v-5.71h0L185,386h12.22v.27c-.05,11.05-.1,20.67-.13,27.58,0,3.38-.06,6.09-.07,8,0,.9,0,1.6,0,2.13A6,6,0,0,1,197,424.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.08,
    y: 422.24,
    width: 48.93,
    height: 20.82,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,443.06a3.26,3.26,0,0,1,0-.39c0-.28,0-.64,0-1.09,0-1,0-2.39-.05-4.17,0-3.62-.06-8.79-.11-15.17l.2.19-48.93.08c-.25.25.34-.34.28-.27h0V433c0,3.49,0,6.87,0,10.11l-.27-.27,35,.13,10.19.07,2.74,0,.72,0,.25,0h-.22l-.68,0-2.69,0-10.13.08-35.21.12h-.26v-.26c0-3.24,0-6.62,0-10.11,0-1.74,0-3.5,0-5.29v-5.41h0l.28-.28L225,422h.2v.2c-.05,6.43-.08,11.64-.11,15.29,0,1.76,0,3.14,0,4.12,0,.44,0,.79,0,1.06A2.21,2.21,0,0,1,225,443.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 464.32,
    cy: 471.58,
    r: 13.51,
    transform: "translate(-95.45 118.53) rotate(-13.2)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.42,466.42V440.58h24.12V463a5.38,5.38,0,0,1-5.38,5.38h-2a9.22,9.22,0,0,1,.51,4.08,9.57,9.57,0,0,1-9.55,8.53,9.44,9.44,0,0,1-7.74-14.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.38,471.58a3.94,3.94,0,1,0,3.94-3.94A3.94,3.94,0,0,0,460.38,471.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.74,
    y: 421.64,
    width: 48.93,
    height: 20.82,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74,442.46s0-.11,0-.35l0-1.06c0-1,0-2.36-.05-4.12,0-3.65-.06-8.86-.11-15.29v-.2h.2l48.93-.08.28.28h0v10.71c0,3.48,0,6.86,0,10.1v.27h-.27l-35.21-.12-10.13-.07-2.68,0H436l-.22,0,.26,0h.71l2.74,0,10.19-.07,35-.13-.26.27c0-3.24,0-6.62,0-10.1,0-1.75,0-3.51,0-5.3v-5.41h0l.28.27-48.93-.08.2-.19c0,6.38-.08,11.55-.11,15.17,0,1.78,0,3.18-.05,4.17,0,.45,0,.82,0,1.09A1.81,1.81,0,0,1,435.74,442.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.79,348.35l-130.67-123A10,10,0,0,0,79.38,240L209.32,362.26c2.92,2.74,6.9,2.85,10.54,2.6H518V348.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.79,348.35l1.4,0h4.12l16,0,60.39-.07L518,348.1h.25v.25c0,5.11,0,10.78,0,16.51v.25H518l-194,0H222.32c-1,0-2.06,0-3.07,0a26.72,26.72,0,0,1-3.1,0,11.55,11.55,0,0,1-5.91-1.84,19.84,19.84,0,0,1-2.32-2l-2.22-2.09-4.41-4.15-17.44-16.42-33.76-31.79L87.67,248.07l-7.27-6.84a13.47,13.47,0,0,1-3.2-3.8A10.08,10.08,0,0,1,76,232.64a10.32,10.32,0,0,1,4.38-8.39,10.49,10.49,0,0,1,4.48-1.73,10.38,10.38,0,0,1,4.73.47,10.5,10.5,0,0,1,4,2.51l3.35,3.16,6.59,6.21,12.76,12L195,321.07l21.38,20.2,5.56,5.27,1.89,1.81s-.65-.58-1.91-1.76l-5.58-5.21-21.44-20.11L116,247.19l-12.78-12L96.65,229l-3.36-3.16a10.21,10.21,0,0,0-3.82-2.41,9.78,9.78,0,0,0-8.82,1.21,9.81,9.81,0,0,0-3.06,12.61,13,13,0,0,0,3.13,3.68L88,247.74l62.45,58.74,33.77,31.78,17.45,16.42,4.41,4.15,2.22,2.09a20.94,20.94,0,0,0,2.26,2,11,11,0,0,0,5.63,1.73,25.69,25.69,0,0,0,3,0c1-.08,2.05,0,3.08,0H324l194,0-.26.26c0-5.73,0-11.4,0-16.51l.25.26-212.37-.11-60.37-.07-16,0-4.11,0C224.25,348.37,223.79,348.35,223.79,348.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.79,248.1A38.81,38.81,0,0,0,184.26,244a51.55,51.55,0,0,0,9.87-7.06l.62-.2,11.94,3.31c6.44,2.33,24.19,6.64,28.88,9.87,6.61,4.56,11.08,12.54,11.08,12.54l24.93,24s5.47,1.95,2.22,13S242.48,325,242.48,325s-6.86,2.85-10.89-1.27c-3.47-3.55-20.27-19.56-20.27-19.56s-24.71-22-28.91-26.75C173.73,267.53,167,265.25,172.79,248.1Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.37,313.14l25.28-50.67,30.3,4.66,30.2,8.89,89.59-6.71L493.67,278a12.63,12.63,0,0,1,8.65,3.31c2.74,2.51,7,6.52,7.62,11.67,2.48,20.65,4.2,33.78,4,33l-274.26,1.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.2,264.1c1.11.55,20.55,18.94,20.55,18.94l22.67-24.1L260.57,266s-24.26,44.71-29.47,44.84-9.86-2.58-22.92-10.42c-13.55-8.13-18.64-22.34-18.64-22.34Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.76,270.2l-22.63,20s-11.54-15.1-16.37-22.74c-4.32-6.81-2.49-12.25,3.86-16.15s16.31,1.38,20.3,4.24C204.51,258.86,214.76,270.2,214.76,270.2Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.76,270.2a2.6,2.6,0,0,1-.45-.39l-1.21-1.19c-1-1.05-2.54-2.56-4.43-4.39s-4.18-4-6.83-6.23a48.72,48.72,0,0,0-9.23-6.42,14.37,14.37,0,0,0-10.81-1,11.17,11.17,0,0,0-6.87,5.54,9.84,9.84,0,0,0-1,6,14.37,14.37,0,0,0,.6,2.19,5.75,5.75,0,0,1-.81-2.15,9.77,9.77,0,0,1,.83-6.18,11.47,11.47,0,0,1,7.07-5.86,15.07,15.07,0,0,1,5.49-.64,14.44,14.44,0,0,1,5.72,1.62,47.65,47.65,0,0,1,9.31,6.53c2.65,2.28,4.91,4.47,6.77,6.34s3.33,3.42,4.31,4.52l1.14,1.27A2.53,2.53,0,0,1,214.76,270.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.16 290.2 214.76 270.2 210.75 266.03 189.54 286.9 192.16 290.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,250.48s10.56-1.45,16.13-5.73a85.91,85.91,0,0,0,8.88-7.59l-2.82-.58s-7.54,8-21.44,11.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.76,249.34s0,.13-.06.38a7.15,7.15,0,0,1-.33,1,10,10,0,0,1-2.25,3.36,9.82,9.82,0,0,1-2.28,1.7,1.22,1.22,0,0,1-.88.19,1,1,0,0,1-.69-.71,2.53,2.53,0,0,1,.42-1.75,9.59,9.59,0,0,1,5.75-4.74l2.1-.61-1.88,1.11a10,10,0,0,1-2.1.94,22.27,22.27,0,0,1-8.28.47,1.64,1.64,0,0,1-1-.31.77.77,0,0,1-.25-.61,1.1,1.1,0,0,1,.22-.54,2.06,2.06,0,0,1,.77-.62c.27-.13.53-.27.8-.37a9.47,9.47,0,0,1,3.11-.69,9.58,9.58,0,0,1,4.49.83,6.39,6.39,0,0,1,1.09.61c.23.16.35.25.34.27s-.53-.29-1.51-.68a9.92,9.92,0,0,0-4.38-.64,9,9,0,0,0-3,.73,3.1,3.1,0,0,0-1.35.85c-.15.21-.16.37,0,.49a1.19,1.19,0,0,0,.73.17,22.36,22.36,0,0,0,8.08-.49,10.26,10.26,0,0,0,2-.88l.22.5a9.22,9.22,0,0,0-5.48,4.44,2.23,2.23,0,0,0-.4,1.39.55.55,0,0,0,.35.4.83.83,0,0,0,.57-.14,9.76,9.76,0,0,0,2.22-1.58,10.33,10.33,0,0,0,2.32-3.17C173.58,249.83,173.72,249.33,173.76,249.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.37,262.07s.65-4.09,3.38-4.21c0,0,2.68-.72,3.68-.87a16.44,16.44,0,0,1,2.1-.15l5.46-.24a3.48,3.48,0,0,1,2.74-2.06c1.88-.06,2.32,2,2.32,2l.16,3.32s1.35-1.09,2.41-.14,1.51,2.87,1.06,3.15-1.4,1-1.4,1l.45,2.17a12.58,12.58,0,0,1-2.55,1.77c-.53.07-3.69.72-3.69.72L248,265.19S244.63,263.42,244.37,262.07Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.58,259.3a1.57,1.57,0,0,0,0-1.58c-.43-1-1-1.71-2-1.68s-5.11,1.51-3.24,3.13a3.33,3.33,0,0,0,3.79.66A5.25,5.25,0,0,0,265.58,259.3Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.58,259.3s-.16.16-.52.35a4.8,4.8,0,0,1-.68.27c-.28.06-.55.18-.91.28a3.15,3.15,0,0,1-1.21.11,3.39,3.39,0,0,1-1.31-.49,2.86,2.86,0,0,1-1.13-1.09,1.14,1.14,0,0,1-.09-.46,1.22,1.22,0,0,1,.13-.46,2,2,0,0,1,.57-.67,6.89,6.89,0,0,1,2.85-1.25,1.77,1.77,0,0,1,1.41.25,2.74,2.74,0,0,1,.79.94,2.52,2.52,0,0,1,.39,1.66c-.08.42-.27.58-.29.56a3.86,3.86,0,0,0,.12-.58,2.53,2.53,0,0,0-.49-1.49,2.46,2.46,0,0,0-.72-.79,1.46,1.46,0,0,0-1.14-.16,7,7,0,0,0-2.64,1.2c-.38.31-.69.73-.49,1.09a2.6,2.6,0,0,0,.95.91,2.76,2.76,0,0,0,2.22.42c.33-.07.66-.19.93-.22a5.31,5.31,0,0,0,.68-.19A2.26,2.26,0,0,1,265.58,259.3Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.75,255.49a2.63,2.63,0,0,0-1.87-2c-1.53-.34-4.65-.09-5,1.14s-.07,1.72.53,1.93a47.51,47.51,0,0,0,5.71-.17Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.75,255.49a4.34,4.34,0,0,1-.59,1l0,0h-.05c-.73.09-1.81.19-3.11.28-.65,0-1.36.07-2.12.06a2.08,2.08,0,0,1-.63-.09,1.19,1.19,0,0,1-.56-.42,1.66,1.66,0,0,1-.16-1.33,4,4,0,0,1,.13-.46,1.51,1.51,0,0,1,.29-.45,2.66,2.66,0,0,1,.8-.5,5.73,5.73,0,0,1,1.66-.37,7,7,0,0,1,2.83.22,2.49,2.49,0,0,1,1.37,1.33c.19.42.2.68.17.68s-.1-.23-.32-.6a2.4,2.4,0,0,0-1.33-1.12,7.24,7.24,0,0,0-2.68-.11,5.6,5.6,0,0,0-1.53.37,2.1,2.1,0,0,0-.66.41.91.91,0,0,0-.19.29c0,.12-.08.27-.11.4a1.31,1.31,0,0,0,.08,1,.75.75,0,0,0,.37.27,1.68,1.68,0,0,0,.48.07c.74,0,1.44,0,2.09,0l3.11-.11-.08,0A5.49,5.49,0,0,1,259.75,255.49Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.28,263.86s.78-1.08,1.43-.8,1.34,2.25,1.25,2.62-2.47,1.15-2.41.49A11.83,11.83,0,0,0,266.28,263.86Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.28,263.86a4,4,0,0,1,.38,1.4,4.11,4.11,0,0,1,.08.75c0,.05,0,.17,0,.18h0a.7.7,0,0,0,.31,0,3.89,3.89,0,0,0,1.65-.58l0,0v0a.88.88,0,0,0,0-.21,3.69,3.69,0,0,0-.11-.45,6.81,6.81,0,0,0-.32-.83c-.24-.49-.53-1-.87-.93a1.66,1.66,0,0,0-.83.46c-.19.15-.29.25-.31.23s0-.15.18-.35a1.6,1.6,0,0,1,.92-.64.84.84,0,0,1,.78.32,3.17,3.17,0,0,1,.49.74,6.89,6.89,0,0,1,.37.87,4.07,4.07,0,0,1,.13.5,2.36,2.36,0,0,1,0,.28.43.43,0,0,1,0,.21.59.59,0,0,1-.14.18,3.15,3.15,0,0,1-1,.47,4.06,4.06,0,0,1-1,.18,1,1,0,0,1-.53-.09.37.37,0,0,1-.19-.32c0-.12,0-.13,0-.21,0-.24,0-.48,0-.7A5.44,5.44,0,0,1,266.28,263.86Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.38,262.87c-.07,0,0-.3,0-.68a2.87,2.87,0,0,0-.35-1.45c-.39-1.22-1.49-1.32-1.48-1.44s.28-.17.73,0a1.67,1.67,0,0,1,.71.44,2.81,2.81,0,0,1,.51.83,2.42,2.42,0,0,1,.24,1.72C267.63,262.69,267.44,262.89,267.38,262.87Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.18,
    y: 322.08,
    width: 287.04,
    height: 26.28,
    rx: 4.99,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.37,322.08c0,.15-56.55.53-126.28.84s-126.29.44-126.29.29,56.53-.54,126.29-.85S498.37,321.92,498.37,322.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.53,277.11c.15,0,.28,23,.28,51.3s-.13,51.3-.28,51.3-.28-23-.28-51.3S516.38,277.11,516.53,277.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.64,348.51,102.56,234.35a5.44,5.44,0,0,1-.61-7.62l9.72-10.38a5.42,5.42,0,0,1,7.7.2L240.21,333.24c2.25,2.18,4.23,9.92,2.26,11.95l.12,4.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.8,
    y: 364.86,
    width: 408.31,
    height: 23.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.89,
    y: 365.01,
    width: 408.31,
    height: 23.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92.8,
    y: 364.86,
    width: 408.31,
    height: 23.83
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M108.08,388.83H89.58V352a7.88,7.88,0,0,1,7.88-7.88h2.74a7.88,7.88,0,0,1,7.88,7.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.08,388.83a1.14,1.14,0,0,1,0-.32c0-.24,0-.55,0-.93,0-.84,0-2-.05-3.52,0-3.07,0-7.45-.09-12.83s-.05-11.83-.08-19a7.66,7.66,0,0,0-6.23-7.78,15.2,15.2,0,0,0-2.89-.13,12.85,12.85,0,0,0-2.92.19,7.63,7.63,0,0,0-5.78,6,15.41,15.41,0,0,0-.14,2.9v5.79c0,3.79,0,7.46,0,11,0,7,0,13.3,0,18.65l-.21-.2,13.47.11,3.7.05,1,0,.35,0a1.2,1.2,0,0,1-.31,0l-.94,0-3.65.05-13.6.11h-.2v-.21c0-5.35,0-11.66,0-18.65,0-3.5,0-7.17,0-11v-5.79a14.55,14.55,0,0,1,.15-3,8.06,8.06,0,0,1,1.14-2.86A8.17,8.17,0,0,1,95.66,344a13.14,13.14,0,0,1,3-.2,15.89,15.89,0,0,1,3,.14,8.17,8.17,0,0,1,6.64,8.32c0,7.18,0,13.65-.07,19.1s-.08,9.75-.1,12.82c0,1.47,0,2.63,0,3.46,0,.36,0,.65,0,.89S108.08,388.84,108.08,388.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.83,394.27,501.2,372.49a15.21,15.21,0,0,0-10.54-4.24H429.94A19.87,19.87,0,0,0,417,373c-5.62,4.83-14.66,12.69-23.85,20.7-11.08,9.66-4.25,27.9,10.45,27.9H512.8C527.12,421.64,534.15,404.2,523.83,394.27Zm-88.09,10.41a5.9,5.9,0,0,1-5.89,5.9H407.07a4.84,4.84,0,0,1-3.29-8.38l23.84-22.14a4.83,4.83,0,0,1,8.12,3.54Zm38.5.19a5.11,5.11,0,0,1-5.12,5.11H449.61a5.11,5.11,0,0,1-5.11-5.11v-21a5.11,5.11,0,0,1,5.11-5.11h19.51a5.11,5.11,0,0,1,5.12,5.11Zm37.09,5.71H488.55a5.9,5.9,0,0,1-5.9-5.9V383.6a4.83,4.83,0,0,1,8.12-3.54l23.84,22.14A4.83,4.83,0,0,1,511.33,410.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.83,394.27,501.2,372.49a15.21,15.21,0,0,0-10.54-4.24H429.94A19.87,19.87,0,0,0,417,373c-5.62,4.83-14.66,12.69-23.85,20.7-11.08,9.66-4.25,27.9,10.45,27.9H512.8C527.12,421.64,534.15,404.2,523.83,394.27Zm-88.09,10.41a5.9,5.9,0,0,1-5.89,5.9H407.07a4.84,4.84,0,0,1-3.29-8.38l23.84-22.14a4.83,4.83,0,0,1,8.12,3.54Zm38.5.19a5.11,5.11,0,0,1-5.12,5.11H449.61a5.11,5.11,0,0,1-5.11-5.11v-21a5.11,5.11,0,0,1,5.11-5.11h19.51a5.11,5.11,0,0,1,5.12,5.11Zm37.09,5.71H488.55a5.9,5.9,0,0,1-5.9-5.9V383.6a4.83,4.83,0,0,1,8.12-3.54l23.84,22.14A4.83,4.83,0,0,1,511.33,410.58Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.33,410.58s.38,0,1.08-.19a4.64,4.64,0,0,0,2.56-1.64,4.78,4.78,0,0,0,.77-4.59l-.3-.65-.41-.61c-.18-.19-.35-.38-.53-.56l-.6-.56c-.81-.75-1.67-1.54-2.58-2.36l-12.67-11.69-7.47-6.91a6,6,0,0,0-2.07-1.47,4.47,4.47,0,0,0-2.51-.21,4.57,4.57,0,0,0-3.55,3.43,15.11,15.11,0,0,0-.12,2.72V388c0,1.82,0,3.62,0,5.39,0,3.52,0,6.93,0,10.17a9.89,9.89,0,0,0,.14,2.34,5.49,5.49,0,0,0,.91,2,5.66,5.66,0,0,0,3.51,2.27,10.25,10.25,0,0,0,2.08.11h2.05l3.85,0,11.62.09,3.16,0,.82,0,.28,0a.9.9,0,0,1-.28,0l-.82,0-3.16.05-11.62.09-3.85,0h-2.05a10.74,10.74,0,0,1-2.17-.11,6.09,6.09,0,0,1-3.82-2.44,6,6,0,0,1-1-2.2,10.68,10.68,0,0,1-.17-2.45c0-3.24,0-6.65,0-10.17,0-1.77,0-3.57,0-5.39v-2.75a14.49,14.49,0,0,1,.14-2.84,5.13,5.13,0,0,1,6.8-3.62,6.79,6.79,0,0,1,2.25,1.59l7.44,6.94,12.59,11.77,2.55,2.39a14.1,14.1,0,0,1,1.15,1.17l.43.66c.11.24.21.48.31.71a5,5,0,0,1-.89,4.83,4.64,4.64,0,0,1-2.71,1.61A4,4,0,0,1,511.33,410.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.24,404.87a1.11,1.11,0,0,1,0-.29c0-.23,0-.51,0-.86,0-.79,0-1.9-.05-3.3,0-2.9-.05-7-.09-12.12,0-1.28,0-2.62,0-4a5,5,0,0,0-5.47-5.28H450.2a5.36,5.36,0,0,0-2.64.46,4.85,4.85,0,0,0-2.78,4.37c0,3.91,0,7.72,0,11.4v5.42c0,.89,0,1.77,0,2.63a15.76,15.76,0,0,0,.09,2.51,4.9,4.9,0,0,0,2.85,3.52,5.26,5.26,0,0,0,2.22.39h2.29l8.38,0,6.9,0a13.1,13.1,0,0,0,2.79-.12,5.06,5.06,0,0,0,3.77-3.71c.17-.73.15-1.13.19-1.13a3.85,3.85,0,0,1-.08,1.15,5.08,5.08,0,0,1-1.67,2.84,5.24,5.24,0,0,1-2.14,1.11,13.22,13.22,0,0,1-2.86.17l-6.9,0-8.38,0h-2.29a5.82,5.82,0,0,1-2.41-.42,5.41,5.41,0,0,1-3.16-3.86,15.49,15.49,0,0,1-.11-2.62c0-.86,0-1.74,0-2.63v-5.42c0-3.68,0-7.49,0-11.4a5.4,5.4,0,0,1,3.1-4.87,5.94,5.94,0,0,1,2.88-.51h13.4l4.95,0a5.57,5.57,0,0,1,4.4,1.63,5.49,5.49,0,0,1,1.5,4.14c0,1.39,0,2.73,0,4,0,5.09-.06,9.22-.08,12.12,0,1.4,0,2.51-.06,3.3,0,.35,0,.63,0,.86A1.11,1.11,0,0,1,474.24,404.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74,404.68a1,1,0,0,1,0-.28c0-.22,0-.49,0-.82,0-.77,0-1.82-.06-3.16,0-2.79-.05-6.75-.08-11.62,0-1.23,0-2.51,0-3.85,0-.67,0-1.37-.06-2a4.82,4.82,0,0,0-.72-1.87,4.64,4.64,0,0,0-3.56-2,4.38,4.38,0,0,0-2.16.39,7.2,7.2,0,0,0-1.84,1.39l-15.45,14.38c-2.73,2.55-5.45,5-8,7.43a4.56,4.56,0,0,0,2.29,7.58,12,12,0,0,0,2.34.13h2.34l4.47,0,8,0,6.63,0a5.85,5.85,0,0,0,5.73-4.65c.15-.71.12-1.09.16-1.09a3.59,3.59,0,0,1-.05,1.11,5.73,5.73,0,0,1-1.35,2.86,6,6,0,0,1-4.49,2.08l-6.63,0-8,0h-6.81a12.14,12.14,0,0,1-2.45-.13,5.08,5.08,0,0,1-2.57-8.45c2.57-2.46,5.25-4.91,8-7.47,5.48-5.09,10.71-9.93,15.47-14.34a7.82,7.82,0,0,1,2-1.48,5,5,0,0,1,2.4-.42,5.15,5.15,0,0,1,3.92,2.26,5.32,5.32,0,0,1,.77,2.07c.08.74,0,1.41,0,2.08,0,1.34,0,2.62,0,3.85,0,4.87-.07,8.83-.09,11.62,0,1.34,0,2.39-.05,3.16,0,.33,0,.6,0,.82A1,1,0,0,1,435.74,404.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.83,394.27s.21.2.59.62l.72.79.47.51c.13.21.28.43.43.66a14.75,14.75,0,0,1,2.76,9.23,17.5,17.5,0,0,1-.41,3.35,18.09,18.09,0,0,1-1.29,3.49,16.13,16.13,0,0,1-5.52,6.28,16.4,16.4,0,0,1-9.22,2.61l-10.82,0-53.25.06-31.45,0H404.42a18.41,18.41,0,0,1-4.24-.35,15.43,15.43,0,0,1-7.59-3.93,16.53,16.53,0,0,1-4.53-7.38,16,16,0,0,1,1.51-12.67,17.5,17.5,0,0,1,2.68-3.37c4.22-3.77,8.44-7.35,12.55-10.94l12.14-10.52a20.36,20.36,0,0,1,6.85-3.8,22.17,22.17,0,0,1,7.59-1l53.26.06h5.54a16,16,0,0,1,5.25.77,15.2,15.2,0,0,1,4.43,2.32,42.85,42.85,0,0,1,3.46,3.17l11.1,10.74,7,6.81,1.81,1.78c.41.4.61.62.61.62s-.23-.19-.65-.58L521.34,392l-7.07-6.73L503.1,374.54a41.47,41.47,0,0,0-3.44-3.12,14.78,14.78,0,0,0-4.34-2.25,15.31,15.31,0,0,0-5.14-.73h-5.54l-53.26.06a21.55,21.55,0,0,0-7.43.94,19.6,19.6,0,0,0-6.67,3.71l-12.12,10.52c-4.1,3.59-8.35,7.2-12.53,10.93a16.92,16.92,0,0,0-2.58,3.25,15.14,15.14,0,0,0-1.6,3.86,15.66,15.66,0,0,0,.15,8.37,16,16,0,0,0,4.37,7.14,14.93,14.93,0,0,0,7.32,3.79,17.83,17.83,0,0,0,4.13.34h12.42l31.45,0,53.25.06,10.82,0a16.13,16.13,0,0,0,9-2.52,15.91,15.91,0,0,0,5.45-6.14,17.8,17.8,0,0,0,1.3-3.43,17,17,0,0,0,.42-3.29,14.8,14.8,0,0,0-2.63-9.17l-.42-.66-.45-.51-.7-.81C524,394.5,523.83,394.27,523.83,394.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.92,
    y: 337.2,
    width: 10.91,
    height: 27.81,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.83,365a3.52,3.52,0,0,1,0-.57c0-.41,0-.93,0-1.57,0-1.42,0-3.38-.08-5.82,0-5-.07-11.87-.12-19.85l.27.27H356.92c.55-.56.15-.15.28-.27h0v2c0,.67,0,1.34,0,2v3.93c0,2.57,0,5,0,7.4,0,4.7,0,8.91-.06,12.43l-.19-.2,7.93.11L367,365a4.84,4.84,0,0,1,.79,0s-.24,0-.72,0l-2.14.05-8.05.1h-.19V365c0-3.52,0-7.73-.06-12.43,0-2.36,0-4.83,0-7.4,0-1.29,0-2.6,0-3.93v-4h0c.12-.13-.28.27.28-.29l10.91,0h.26v.26c0,8.05-.09,15-.12,20,0,2.41-.06,4.35-.08,5.75,0,.62,0,1.12,0,1.52A2.9,2.9,0,0,1,367.83,365Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.51,
    y: 337.2,
    width: 10.91,
    height: 27.81,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.42,365a4.66,4.66,0,0,1,0-.57l0-1.57c0-1.42,0-3.38-.07-5.82,0-5-.08-11.87-.13-19.85l.27.27H259.51c.55-.56.16-.15.28-.27h0v4c0,1.33,0,2.64,0,3.93,0,2.57,0,5,0,7.4,0,4.7,0,8.91-.07,12.43l-.19-.2,7.94.11,2.18.05a4.72,4.72,0,0,1,.79,0,7.13,7.13,0,0,1-.72,0l-2.14.05-8.05.1h-.19V365c0-3.52,0-7.73-.06-12.43q0-3.54,0-7.4c0-1.29,0-2.6,0-3.93v-4h0c.13-.13-.28.27.28-.29l10.91,0h.27v.26c-.05,8.05-.1,15-.13,20,0,2.41-.06,4.35-.07,5.75,0,.62,0,1.12,0,1.52A2.9,2.9,0,0,1,270.42,365Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.1,290.71H212.69c-15,0-21.91,15.91-11,27.38l23.19,24.13a16,16,0,0,0,11.05,4.45H389.5a20.78,20.78,0,0,0,13.56-5c5.89-5.06,16.11-15.59,25.09-24.67C438.82,306.18,434.55,290.71,417.1,290.71ZM242.63,332.17a5.07,5.07,0,0,1-8.78,3.44l-23.21-25a5.06,5.06,0,0,1,3.71-8.51h22.1a6.18,6.18,0,0,1,6.18,6.18Zm40.88-1.8a5.36,5.36,0,0,1-5.36,5.36H257.7a5.36,5.36,0,0,1-5.36-5.36v-22A5.36,5.36,0,0,1,257.7,303h20.45a5.36,5.36,0,0,1,5.36,5.36Zm95.76-1.28a5.36,5.36,0,0,1-5.35,5.36H353.46a5.36,5.36,0,0,1-5.36-5.36v-22a5.36,5.36,0,0,1,5.36-5.36h20.46a5.36,5.36,0,0,1,5.35,5.36ZM421,309.34l-23.21,25a5.07,5.07,0,0,1-8.78-3.45V307a6.18,6.18,0,0,1,6.18-6.18h22.1A5.06,5.06,0,0,1,421,309.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.1,290.71H212.69c-15,0-21.91,15.91-11,27.38l23.19,24.13a16,16,0,0,0,11.05,4.45H389.5a20.78,20.78,0,0,0,13.56-5c5.89-5.06,16.11-15.59,25.09-24.67C438.82,306.18,434.55,290.71,417.1,290.71ZM242.63,332.17a5.07,5.07,0,0,1-8.78,3.44l-23.21-25a5.06,5.06,0,0,1,3.71-8.51h22.1a6.18,6.18,0,0,1,6.18,6.18Zm40.88-1.8a5.36,5.36,0,0,1-5.36,5.36H257.7a5.36,5.36,0,0,1-5.36-5.36v-22A5.36,5.36,0,0,1,257.7,303h20.45a5.36,5.36,0,0,1,5.36,5.36Zm95.76-1.28a5.36,5.36,0,0,1-5.35,5.36H353.46a5.36,5.36,0,0,1-5.36-5.36v-22a5.36,5.36,0,0,1,5.36-5.36h20.46a5.36,5.36,0,0,1,5.35,5.36ZM421,309.34l-23.21,25a5.07,5.07,0,0,1-8.78-3.45V307a6.18,6.18,0,0,1,6.18-6.18h22.1A5.06,5.06,0,0,1,421,309.34Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,309.34s.26-.3.63-1a5,5,0,0,0,.58-3.14,5.08,5.08,0,0,0-3-3.86A7.63,7.63,0,0,0,416,301l-3.67,0-8.41,0-4.68,0h-2.45c-.83,0-1.69,0-2.48.07a6,6,0,0,0-4.1,2.59,5.91,5.91,0,0,0-.91,2.39,21.93,21.93,0,0,0-.07,2.71V329a27.5,27.5,0,0,0,.06,2.75,4.78,4.78,0,0,0,3.19,3.72,4.6,4.6,0,0,0,4.64-.87c4.66-4.87,8.83-9.42,12.35-13.14l8.35-8.87,2.29-2.39.61-.61a1.41,1.41,0,0,1,.22-.2s-.05.09-.18.24l-.57.65L418,312.69l-8.22,9c-3.51,3.78-7.58,8.3-12.31,13.27a5.15,5.15,0,0,1-5.14,1,5.34,5.34,0,0,1-3.56-4.14c-.11-1,0-1.89-.07-2.84V308.84a23.82,23.82,0,0,1,.08-2.79,6.4,6.4,0,0,1,5.48-5.4,20,20,0,0,1,2.55-.07H404l8.41,0,3.67,0a7.71,7.71,0,0,1,3.28.44,5.25,5.25,0,0,1,3.08,4.11,5,5,0,0,1-.7,3.23,3.27,3.27,0,0,1-.52.69C421.05,309.28,421,309.35,421,309.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.27,329.09a1,1,0,0,1,0-.3c0-.24,0-.53,0-.9,0-.83,0-2-.05-3.46,0-3-.06-7.37-.09-12.7,0-1.35,0-2.75,0-4.22a5.21,5.21,0,0,0-5.75-5.54h-5.18L357,302h-2.92a5.75,5.75,0,0,0-2.77.49,5.08,5.08,0,0,0-2.93,4.59V319c0,1.93,0,3.83,0,5.68,0,.93,0,1.85,0,2.76a16.08,16.08,0,0,0,.1,2.63,5.19,5.19,0,0,0,3,3.7,5.65,5.65,0,0,0,2.33.41h2.41l8.77,0,7.24,0a13.76,13.76,0,0,0,2.93-.12,5.09,5.09,0,0,0,2.17-1.07,5.29,5.29,0,0,0,1.78-2.83c.18-.76.16-1.18.19-1.18a3.83,3.83,0,0,1-.08,1.21,5.34,5.34,0,0,1-1.75,3,5.46,5.46,0,0,1-2.25,1.16,13.74,13.74,0,0,1-3,.18l-7.24,0-8.77,0h-2.41a6.19,6.19,0,0,1-2.52-.44,5.69,5.69,0,0,1-3.3-4,17,17,0,0,1-.12-2.74v-2.76c0-1.85,0-3.75,0-5.68V307.08a5.65,5.65,0,0,1,3.24-5.09,6.24,6.24,0,0,1,3-.54H357l11.13,0h5.18a5.83,5.83,0,0,1,4.61,1.71,5.75,5.75,0,0,1,1.57,4.32c0,1.47,0,2.87,0,4.22,0,5.33-.07,9.66-.09,12.7,0,1.47,0,2.63-.05,3.46,0,.37,0,.66,0,.9A1.16,1.16,0,0,1,379.27,329.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.51,330.37a1.3,1.3,0,0,1,0-.31q0-.35,0-.9c0-.83,0-2-.05-3.45,0-3,0-7.38-.09-12.71,0-1.34,0-2.75,0-4.21a5.27,5.27,0,0,0-1.47-4,5.33,5.33,0,0,0-4.28-1.55l-5.18,0H258.31a5.75,5.75,0,0,0-2.77.49,5.12,5.12,0,0,0-2.93,4.6v11.95c0,1.93,0,3.82,0,5.68v2.75a17.5,17.5,0,0,0,.09,2.64,5.16,5.16,0,0,0,3,3.69,5.6,5.6,0,0,0,2.33.42h2.4l8.78,0,7.24,0a13,13,0,0,0,2.92-.13,5.19,5.19,0,0,0,2.17-1.06,5.26,5.26,0,0,0,1.78-2.83c.18-.76.16-1.19.2-1.18a4,4,0,0,1-.09,1.2,5.25,5.25,0,0,1-1.75,3,5.36,5.36,0,0,1-2.24,1.16,13.78,13.78,0,0,1-3,.18l-7.24,0-8.78,0H258a6,6,0,0,1-2.52-.44,5.64,5.64,0,0,1-3.31-4,15.79,15.79,0,0,1-.11-2.74c0-.9,0-1.82,0-2.75,0-1.86,0-3.75,0-5.68v-12a5.65,5.65,0,0,1,3.24-5.09,6.36,6.36,0,0,1,3-.54h14.05l5.18,0a5.83,5.83,0,0,1,4.61,1.7,5.73,5.73,0,0,1,1.57,4.33c0,1.46,0,2.87,0,4.21,0,5.33-.06,9.67-.09,12.71,0,1.47,0,2.62-.05,3.45,0,.37,0,.67,0,.9A1.3,1.3,0,0,1,283.51,330.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.63,332.17a1.16,1.16,0,0,1,0-.3c0-.22,0-.51,0-.86,0-.8,0-1.91,0-3.31,0-2.92-.05-7.07-.09-12.18,0-1.29,0-2.63,0-4,0-.7,0-1.41,0-2.14a11.26,11.26,0,0,0-.11-2.18,6,6,0,0,0-2.39-3.69,6,6,0,0,0-2.13-1,10.87,10.87,0,0,0-2.45-.15l-10.67,0h-8.53a14.09,14.09,0,0,0-2.85.13,4.79,4.79,0,0,0-3.61,3.72,4.74,4.74,0,0,0,.22,2.64,6.63,6.63,0,0,0,1.54,2.18l7.25,7.83,12.25,13.28,2.48,2.7.58.63.59.55.65.44.68.31a5.07,5.07,0,0,0,4.82-.81,4.88,4.88,0,0,0,1.71-2.69c.18-.73.16-1.14.2-1.13a1,1,0,0,1,0,.29,3.44,3.44,0,0,1-.09.86,4.83,4.83,0,0,1-1.69,2.83,5.23,5.23,0,0,1-5,.94l-.74-.32-.69-.46-.64-.58-.59-.62-2.51-2.67-12.33-13.2L211,311.43a6.9,6.9,0,0,1-1.66-2.35,5.21,5.21,0,0,1-.25-2.95,5.35,5.35,0,0,1,4-4.16,15.83,15.83,0,0,1,3-.14h19.2a11.1,11.1,0,0,1,2.56.17,6.46,6.46,0,0,1,4.86,5.05,11.74,11.74,0,0,1,.11,2.27c0,.73,0,1.44,0,2.14,0,1.41,0,2.75,0,4,0,5.11-.06,9.26-.09,12.18,0,1.4,0,2.51,0,3.31,0,.35,0,.64,0,.86A1,1,0,0,1,242.63,332.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.1,290.71s.47,0,1.37.05l1.69.08,2.3.39a7.22,7.22,0,0,1,1.36.36l1.49.48a15.46,15.46,0,0,1,1.56.73l.82.4c.26.17.52.37.78.55a12.46,12.46,0,0,1,5.12,7.14,13.93,13.93,0,0,1,.34,5.31,17.32,17.32,0,0,1-1.83,5.58,22.58,22.58,0,0,1-3.76,5.19l-4.83,4.92c-3.35,3.4-6.92,7-10.76,10.85-1.92,1.91-3.91,3.86-6,5.81-1.05,1-2.11,2-3.22,2.92a21.3,21.3,0,0,1-3.63,2.63,21,21,0,0,1-8.82,2.71c-1.59.11-3.17.05-4.78.07h-4.86l-20.43,0-45.07,0-49.81,0h-29.7a18.49,18.49,0,0,1-3.39-.25,16.29,16.29,0,0,1-6.32-2.59,15.58,15.58,0,0,1-2.61-2.24l-2.36-2.46L217,334.46l-9.46-9.85-4.69-4.88a30.08,30.08,0,0,1-2.27-2.5c-.36-.44-.75-.85-1.07-1.32l-.91-1.43-.45-.72-.35-.77-.69-1.55-.48-1.62-.23-.81-.11-.84a14.84,14.84,0,0,1,.42-6.66,15.15,15.15,0,0,1,8.58-9.6,17.33,17.33,0,0,1,3.12-1c.54-.11,1.07-.24,1.61-.33l1.62-.1c1.09-.11,2.15-.06,3.22-.07H255l84.35.06,56.87.09,15.46,0,4,0,1.37,0-1.37,0-4,0-15.46.06-56.87.08L255,291H214.87c-1.07,0-2.14,0-3.19.07l-1.58.1c-.52.09-1,.21-1.56.32a16.24,16.24,0,0,0-3,.94,14.65,14.65,0,0,0-8.28,9.25,14.36,14.36,0,0,0-.39,6.42l.1.81.23.79.45,1.57.68,1.5.34.75.44.7.88,1.39c.32.45.7.86,1,1.29.68.86,1.47,1.66,2.25,2.47l4.69,4.88,9.46,9.84,4.74,4.94c1.62,1.6,3,3.41,4.9,4.63a15.48,15.48,0,0,0,6.1,2.5,17.25,17.25,0,0,0,3.29.25h29.7l49.81,0,45.07,0h25.29c1.61,0,3.21,0,4.75-.06a20.67,20.67,0,0,0,8.66-2.64,38.62,38.62,0,0,0,6.78-5.48c2.09-1.95,4.08-3.89,6-5.79,3.85-3.8,7.43-7.42,10.79-10.81l4.85-4.91a22.49,22.49,0,0,0,3.72-5.11,17.09,17.09,0,0,0,1.83-5.49,13.87,13.87,0,0,0-.31-5.22,12.26,12.26,0,0,0-5-7.06c-.26-.19-.51-.38-.77-.55l-.81-.41c-.54-.25-1-.55-1.54-.73l-1.47-.49a6.67,6.67,0,0,0-1.35-.37l-2.29-.42-1.68-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.46,296.37c0,.16-37.16.28-83,.28s-83-.12-83-.28,37.15-.28,83-.28S382.46,296.22,382.46,296.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.52,436.16l.5,21.48s-20.85,7.75-21.13,11.73l40.13.49.54-33.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.45,456a1.7,1.7,0,0,1,1.11,2,1.58,1.58,0,0,1-1.85,1.16,1.81,1.81,0,0,1-1.17-2.08,1.61,1.61,0,0,1,2.06-1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588,469.86l-.07-3.38-38.45.79s-1.79.79-1.61,2.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M568.38,457.42c0,.21,1,.31,1.93,1s1.47,1.53,1.65,1.45-.1-1.26-1.27-2S568.33,457.24,568.38,457.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.15,459.18c0,.2.79.56,1.45,1.42s.84,1.79,1,1.78.34-1.16-.5-2.22S564.15,459,564.15,459.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.7,464.39c.17,0,.46-1,0-2.09s-1.4-1.58-1.49-1.41.48.77.87,1.7S561.5,464.37,561.7,464.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.78,452.52c.08.18,1-.09,2.09,0s2,.47,2.07.3-.72-.91-2-1S568.69,452.35,568.78,452.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "568.63 440.41 568.71 444.24 588.43 444.3 588.5 440.85 568.63 440.41"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M568.76,448.18a3.66,3.66,0,0,0,2,0,8.7,8.7,0,0,0,2.11-.64,8.87,8.87,0,0,0,1.16-.63,2.28,2.28,0,0,0,.61-.48.92.92,0,0,0,.11-1.08,1.1,1.1,0,0,0-.86-.48,2.78,2.78,0,0,0-.75.1,7.77,7.77,0,0,0-1.26.43,7.24,7.24,0,0,0-1.86,1.24c-.95.89-1.27,1.64-1.21,1.68s.55-.56,1.51-1.29a8,8,0,0,1,1.8-1,6.83,6.83,0,0,1,1.16-.36c.43-.11.79-.11.9.09s0,.1-.05.23a2,2,0,0,1-.45.35,9.18,9.18,0,0,1-1.07.62,11.11,11.11,0,0,1-2,.75A13.56,13.56,0,0,0,568.76,448.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569,448.47a3.32,3.32,0,0,0,.55-2,6.87,6.87,0,0,0-.24-2.29,7.43,7.43,0,0,0-.5-1.27,1.67,1.67,0,0,0-1.27-1.07,1,1,0,0,0-.85.57,3.12,3.12,0,0,0-.21.76,4.78,4.78,0,0,0,0,1.41,5.06,5.06,0,0,0,.83,2.17c.78,1.09,1.59,1.34,1.61,1.27s-.61-.5-1.2-1.55a4.92,4.92,0,0,1-.62-2,4.46,4.46,0,0,1,.06-1.2c.06-.44.23-.8.39-.75s.53.34.69.69a8,8,0,0,1,.49,1.14,7.77,7.77,0,0,1,.36,2.09C569.12,447.68,568.91,448.44,569,448.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.9,428.09l13.51,16.72s-11.8,18.86-9.59,22.18l32.09-24.09-20-26.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.24,435.92a1.71,1.71,0,0,1,2.08.87,1.58,1.58,0,0,1-.76,2,1.81,1.81,0,0,1-2.2-.93,1.62,1.62,0,0,1,1-2",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M631.91,442.9l-2.12-2.64-30,24.09s-1,1.72,0,2.64Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M608.76,445c.13.16,1-.35,2.13-.41s2.09.32,2.19.15-.85-.94-2.26-.85S608.61,444.91,608.76,445Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.48,449c.08.18,1-.05,2,.24s1.75.9,1.9.77-.44-1.12-1.75-1.45S606.37,448.85,606.48,449Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.72,454.62c.17-.07-.23-1.05-1.3-1.63s-2.07-.4-2-.21.85.32,1.72.82S607.55,454.72,607.72,454.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.09,440.89c.18.1.73-.66,1.66-1.27s1.84-.83,1.82-1-1.13-.28-2.22.45S605.91,440.82,606.09,440.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "598.58 431.4 600.98 434.38 616.64 422.39 614.59 419.62 598.58 431.4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M603.42,437.47c.05.07.75-.29,1.6-1.21a9,9,0,0,0,1.28-1.8,9.45,9.45,0,0,0,.54-1.2,2.16,2.16,0,0,0,.19-.76.91.91,0,0,0-.58-.92,1.05,1.05,0,0,0-1,.14,2.5,2.5,0,0,0-.54.54,7,7,0,0,0-1.45,3.23,3.48,3.48,0,0,0,.07,2.07c.11,0,.09-.79.4-1.95a7.89,7.89,0,0,1,.81-1.91,6.9,6.9,0,0,1,.7-1c.27-.35.55-.57.76-.47s.1.05.1.21a1.93,1.93,0,0,1-.14.55,10.32,10.32,0,0,1-1.56,2.93C603.93,436.89,603.35,437.39,603.42,437.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.8,437.55c.08,0,0-.83-.79-1.93a6.8,6.8,0,0,0-1.59-1.66,7.42,7.42,0,0,0-1.17-.71,1.71,1.71,0,0,0-1.66-.07.93.93,0,0,0-.32,1,3.36,3.36,0,0,0,.29.74,4.86,4.86,0,0,0,.85,1.12,5,5,0,0,0,2,1.21c1.28.39,2.08.1,2.05,0a19,19,0,0,1-1.9-.49,5.06,5.06,0,0,1-1.68-1.19,4.41,4.41,0,0,1-.7-1c-.22-.39-.3-.77-.15-.83a1.2,1.2,0,0,1,1,.12,7.85,7.85,0,0,1,1.07.61,7.65,7.65,0,0,1,1.57,1.43C603.41,436.86,603.7,437.59,603.8,437.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.81,284s4.77,17.42,3.84,23.31c-.31,2-1.79,8.09-2.81,12.8-1.77,8.18-3.49,18.4-4,20.45l-5.48,30.81L594,402.45s.44,31.83-.8,47.33l-26.73-.15L558,376.07v-90.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "601.46 440.04 576.5 405.29 590.8 368.47 620.89 425.33 601.46 440.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.88,340.54a5.3,5.3,0,0,0-.13.57c-.09.41-.2,1-.34,1.67-.28,1.5-.68,3.63-1.19,6.31-1,5.46-2.39,13.15-4,22.22h0c-.62,6.68-1.33,14.18-2.07,22.08-.09.92-.17,1.83-.26,2.74s-.18,1.81-.18,2.71c0,1.8-.1,3.58-.14,5.32-.08,3.48-.14,6.84-.15,10,0,6.39,0,12.15,0,17s-.09,8.75-.13,11.45c0,1.32,0,2.37,0,3.11v.82a.8.8,0,0,0,0,.27,1.87,1.87,0,0,0,0-.27c0-.21,0-.48.05-.81,0-.75.08-1.79.14-3.11.1-2.71.22-6.62.28-11.46s0-10.6.08-17c0-3.2.08-6.55.17-10,0-1.74.1-3.51.15-5.3,0-.9.1-1.8.18-2.71s.17-1.82.26-2.74c.72-7.89,1.41-15.39,2-22.07v0l3.87-22.25c.45-2.69.81-4.83,1.07-6.33.11-.71.19-1.27.26-1.68A2.92,2.92,0,0,0,601.88,340.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.48,157.21l3,10.93L544.6,170s.73,6,.72,7.3-2.08,7.83-2.08,7.83l3.33,6.15-10.49,3.29s-2.43-5.59-3.16-6.25-1.18-2.45-1.29-3.64-1.2-8.32-1.2-8.32-4-8-2.13-8.31a6.85,6.85,0,0,1,1.42.11s2.42,5.28,3.14,5.43l1.07-.54s-1.64-7.93-1.66-9.4.35-2.47,1.49-2.57c0,0,.82.39.87.77s1.63,9.21,2.13,9.08.31-.94.31-.94-2.17-10.73-2-11.33a1.66,1.66,0,0,1,1.79-1.34l1.8,5.93s-.7-4.94.14-5.76A1.38,1.38,0,0,1,540.48,157.21Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.82,180.77c.08,0,.08-.91.52-2.35a9.14,9.14,0,0,1,3.48-4.72l.15-.1,0-.17c-.12-.78-.26-1.61-.4-2.46v-.05l0,0c-.16-.26-.33-.56-.48-.87a9.52,9.52,0,0,1-1-3.16,3.28,3.28,0,0,1,.11-1.45,1,1,0,0,1,.82-.74l-.17-.07c1.15,1.25,2.12,2.27,2.81,3a6.14,6.14,0,0,0,1.13,1.06,7.4,7.4,0,0,0-.94-1.24c-.63-.76-1.54-1.83-2.66-3.11l-.07-.08H540a1.46,1.46,0,0,0-1.28,1,3.78,3.78,0,0,0-.17,1.67,9.59,9.59,0,0,0,1,3.35,9.05,9.05,0,0,0,.51.92l0-.1c.15.85.29,1.68.43,2.46l.12-.26a8.92,8.92,0,0,0-3.53,5.07,8.27,8.27,0,0,0-.26,1.79A1.78,1.78,0,0,0,536.82,180.77Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.36,172.1a7.36,7.36,0,0,0-3.34,1.22,7.27,7.27,0,0,0-2.73,2.27,29.73,29.73,0,0,0,3-1.81A31,31,0,0,0,537.36,172.1Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.7,136a3.46,3.46,0,0,0,3.81-2.54,8.72,8.72,0,0,1-6.22.19,7.59,7.59,0,0,0-4.19-13.84c-3.2,0-7,3.22-8,6.26l4,7.28a9.11,9.11,0,0,0,15.21,2.36A7.37,7.37,0,0,1,626.7,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574,183.82v-2.57c1.33-19.27-1.08-41.3,2.78-46.84,6.55-9.41,21.13-11.85,21.13-11.85,21.23-.74,26.06,18.54,29.77,32.92,2.86,11.07,4,73.83.38,73.89l-12.95,3.45L569,225.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.88,128l1.37-1.21,14.11,6.29a4,4,0,0,1,3.63,4l-1.83,46.66a13,13,0,0,1-2.83,8.33l-2.11,2.58c-4.81,5.89-14.22,5.05-17.61-1.75a4.77,4.77,0,0,1-.46-1.23,10.08,10.08,0,0,1-.18-1c-.29-3.77-.19-7-.19-7-.11-4.13-.13-5.82-.13-5.78s-8.74-1.33-10.7-12.68c-1-5.64-.47-13.34.14-20.91C578.93,133.74,586.44,127.66,594.88,128Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.46,152.27a1.45,1.45,0,0,0,1.43,1.45,1.39,1.39,0,0,0,1.48-1.34,1.45,1.45,0,0,0-1.42-1.45A1.4,1.4,0,0,0,595.46,152.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.14,152.27a1.46,1.46,0,0,0,1.43,1.45,1.39,1.39,0,0,0,1.48-1.34,1.45,1.45,0,0,0-1.42-1.45A1.4,1.4,0,0,0,581.14,152.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.48,147.27c.18.18,1.28-.65,2.84-.67s2.73.76,2.9.56-.1-.43-.61-.78a4,4,0,0,0-2.32-.69,3.84,3.84,0,0,0-2.27.77C579.55,146.84,579.39,147.18,579.48,147.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.37,148c.2.17,1.2-.77,2.76-.95s2.8.47,2.94.25-.15-.41-.69-.71a3.93,3.93,0,0,0-2.38-.44,3.86,3.86,0,0,0-2.17,1C595.39,147.57,595.27,147.93,595.37,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.48,159.21a10.43,10.43,0,0,0-2.56-.42c-.4,0-.78-.11-.85-.39a2.08,2.08,0,0,1,.25-1.19c.37-1,.75-2,1.15-3.07,1.58-4.36,2.73-7.95,2.55-8s-1.61,3.42-3.19,7.79c-.38,1.08-.75,2.1-1.1,3.09a2.29,2.29,0,0,0-.18,1.57,1,1,0,0,0,.66.58,3,3,0,0,0,.69.08A9.84,9.84,0,0,0,589.48,159.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.65,177.8a28.9,28.9,0,0,0,15.17-4.27s-3.72,7.92-15.12,7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.19,163a2.86,2.86,0,0,1,2.53-1.08,2.55,2.55,0,0,1,1.79.93,1.64,1.64,0,0,1,.15,1.87,1.9,1.9,0,0,1-2,.55,6,6,0,0,1-2-1.17,1.68,1.68,0,0,1-.46-.46.53.53,0,0,1,0-.58",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.11,160.23c-.25,0-.23,1.7-1.67,2.92s-3.26,1.07-3.27,1.31.41.32,1.17.34a4.28,4.28,0,0,0,2.73-1,3.7,3.7,0,0,0,1.3-2.44C594.42,160.64,594.23,160.22,594.11,160.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.09,141.85c.2.4,1.74,0,3.59,0s3.39.33,3.59-.07c.09-.2-.21-.57-.86-.91a5.94,5.94,0,0,0-2.74-.61,5.88,5.88,0,0,0-2.73.64C594.3,141.28,594,141.65,594.09,141.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580,140.54c.28.36,1.36,0,2.66-.06s2.4.2,2.65-.17c.11-.18-.07-.54-.56-.87a3.86,3.86,0,0,0-4.27.19C580,140,579.83,140.37,580,140.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,157s-8.11,2.21-11.93-17.76c-1.31-6.83-7.38-12.54-7.38-12.54l2.57-.67s15.66,5,15.92,5.24,3.69,8.33,3.69,8.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,156.16c0-.84.94-2.85,1.78-3,2.22-.37,6.25-.25,6.37,5.42.15,7.75-7.66,6.31-7.68,6.09S611.06,159.09,611,156.16Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.81,161.69s.14.09.37.19a1.38,1.38,0,0,0,1,0c.81-.32,1.47-1.63,1.48-3a4.28,4.28,0,0,0-.42-1.93,1.53,1.53,0,0,0-1-1,.68.68,0,0,0-.79.38c-.1.22,0,.37-.09.39s-.17-.13-.11-.45a.85.85,0,0,1,.29-.49,1,1,0,0,1,.75-.21,1.92,1.92,0,0,1,1.43,1.17,4.55,4.55,0,0,1,.51,2.15c0,1.56-.79,3-1.9,3.39a1.46,1.46,0,0,1-1.24-.18C613.83,161.87,613.78,161.7,613.81,161.69Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.91,141.29a57.73,57.73,0,0,0-1.58-5.69,32.17,32.17,0,0,0-1.86-4.44,21.09,21.09,0,0,0-1.67-2.78c-.22-.32-.41-.55-.53-.71a1.43,1.43,0,0,0-.2-.24l.17.26c.11.17.29.41.5.73a25.89,25.89,0,0,1,1.6,2.8,33.58,33.58,0,0,1,1.81,4.44c.57,1.72,1.09,3.64,1.55,5.67a47.32,47.32,0,0,0,1.49,5.71,12.58,12.58,0,0,0,1.12,2.33,9.41,9.41,0,0,0,1.42,1.75,6.83,6.83,0,0,0,2.77,1.67,4.44,4.44,0,0,0,1.18.2s-.43-.05-1.15-.28a6.89,6.89,0,0,1-2.7-1.7,10.37,10.37,0,0,1-1.38-1.73,13,13,0,0,1-1.08-2.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.39,134.91c-.29.08-.71-.49-1.33-1.34-.3-.43-.69-.92-1.11-1.46s-.93-1.09-1.47-1.67c-2.16-2.31-4.37-3.85-4.1-4.39.13-.25.88-.17,2,.29A11.84,11.84,0,0,1,617,129a12,12,0,0,1,1.54,2,9.4,9.4,0,0,1,.84,1.9C619.73,134.07,619.65,134.83,619.39,134.91Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.72,246.26l-15.91-4-14.53-6.64a4.45,4.45,0,0,0-2.08.78c-1.31.79-6.87,5.78-6.87,5.78l-.33,5.74,1.75,5.3s1.28.35,1.75-1.46l1.55,1.77,3,.37,2.45.42,3.87-1.47a2,2,0,0,0-2.09-1.46c-1.7.13-1.89.45-1.89.45l-.62-.49-.06-.9,1.78-.37s8.14,3.53,9.74,2.79a16.12,16.12,0,0,0,2.48-1.39l12.55,6.73Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.16,253.94a2.11,2.11,0,0,0-.3-.34l-.9-.89a13.55,13.55,0,0,1-1.27-1.32c-.36-.58,0-1.35.31-2.1.5-1.39,1-2.67,1.41-3.9.14-.4.27-.8.4-1.19a1.55,1.55,0,0,0,.12-.45,2.75,2.75,0,0,0-.19.42l-.47,1.17c-.47,1.22-.95,2.49-1.47,3.88a11.6,11.6,0,0,0-.39,1.13,1.45,1.45,0,0,0,.11,1.14,3.85,3.85,0,0,0,.7.74l.64.59.94.84A2.32,2.32,0,0,0,523.16,253.94Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.62,242.43a1.9,1.9,0,0,0-.35.29c-.21.2-.51.5-.86.88a21.23,21.23,0,0,0-2.47,3.25,2.87,2.87,0,0,0-.43,2.21,3.76,3.76,0,0,0,.9,1.62l.84.9c.19.22.29.34.31.33a7.57,7.57,0,0,0-1-1.33,3.85,3.85,0,0,1-.82-1.56,2.7,2.7,0,0,1,.43-2.06,25.7,25.7,0,0,1,2.39-3.26l.81-.92A1.9,1.9,0,0,0,520.62,242.43Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.74,247.84s-.39-.52-.84-1.44a2.69,2.69,0,0,1-.24-1.72,4,4,0,0,1,1.19-1.79l2.93-2.79.88-.86a2.11,2.11,0,0,0,.3-.34,1.86,1.86,0,0,0-.36.28l-.92.81c-.77.7-1.83,1.66-3,2.75a4,4,0,0,0-1.23,1.9,2.73,2.73,0,0,0,.3,1.82,6.3,6.3,0,0,0,.67,1A1.69,1.69,0,0,0,516.74,247.84Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.43,250.13a1.83,1.83,0,0,0,.32-2.08c-.06,0,.06.49,0,1.06S526.38,250.1,526.43,250.13Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524,249.74s0,.27.29.47.5.23.51.17-.17-.17-.38-.34S524.08,249.71,524,249.74Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.9,251.81a1.16,1.16,0,0,0,1.13-.05c.61-.3.79-.86.73-.87s-.29.43-.82.68A3.7,3.7,0,0,1,522.9,251.81Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.8,253.83s.47-.32.57-1a1.23,1.23,0,0,0-.23-1.1,6.42,6.42,0,0,1,0,1.07A5.56,5.56,0,0,1,524.8,253.83Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.68,236.77a4.05,4.05,0,0,0-.51.39l-1.36,1.12-4.55,3.83,0,0v.05c0,.48-.06,1-.08,1.48-.09,1.52-.17,3-.24,4.25v0c.49,1.45.93,2.73,1.3,3.82l.38,1.07a1.89,1.89,0,0,0,.16.38,2.68,2.68,0,0,0-.1-.39l-.33-1.1c-.35-1.09-.77-2.38-1.23-3.84v0c.08-1.3.17-2.73.26-4.25,0-.51,0-1,.08-1.48l0,.07,4.51-3.89,1.32-1.17A3.11,3.11,0,0,0,521.68,236.77Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.24,236.54s-18.08-.63-20.25-1.48c-7.75-3-15.85-43.77-15.85-43.77l11.62-3.9L562,211.56l12.66-3.78Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.64,215.71l-14.4,44.76s11.08,25.08,9.78,34.94c-.75,5.72-7.87,16-7.87,16l-55.74-11s7.68-70.46,11.15-82.09c4.89-16.4,20.06-30.69,20.06-30.69h0l.18-7.68h27.75l.43,6S625.75,202.28,622.64,215.71Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.48,309.34a35,35,0,0,0,3.08-7.91,36.86,36.86,0,0,0-3.08,7.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.41,306.61a21.25,21.25,0,0,0,1.72-4.29,21.5,21.5,0,0,0,1.25-4.45,43,43,0,0,0-3,8.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.49,304.27a59.21,59.21,0,0,0,3.7-10.11,28.32,28.32,0,0,0-2.09,5A28.91,28.91,0,0,0,574.49,304.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.35,301.43c.16.06,1-2.32,1.76-5.34l.95-3.85a7.08,7.08,0,0,0,.33-1.61c-.16-.06-1,2.32-1.76,5.34-.34,1.38-.65,2.64-.94,3.85A6.83,6.83,0,0,0,561.35,301.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.42,192.2s-11.59-4.25-17.17-2.58-7.1,3.4-9,6.26l-9.36,46.79-39.25-1.31-2.94,14.9c9.91,6.06,41.75,13.49,47.3,12.25,14-3.1,15.68-11.43,15.68-11.43l14.89-42.9Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.54,201.91s0,.28-.14.81-.29,1.33-.5,2.29c-.46,2-1.11,4.9-1.9,8.42-1.67,7.13-4,16.91-6.48,27.71l-.38,1.59,0,.21h-.21l-27.36-1-8.23-.36-2.23-.12a4.62,4.62,0,0,1-.77-.08,3.92,3.92,0,0,1,.78,0l2.23,0,8.24.2,27.35.85-.26.2L581,241c2.58-10.79,4.92-20.55,6.63-27.68.86-3.5,1.57-6.34,2.07-8.37.24-.95.44-1.71.59-2.27A4.8,4.8,0,0,1,590.54,201.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.37,186.13a4.29,4.29,0,0,1-1,.24c-.67.13-1.64.29-2.84.46-2.39.34-5.72.71-9.41.94s-7,.26-9.45.22c-1.21,0-2.19-.06-2.87-.1a3.82,3.82,0,0,1-1-.12,4.06,4.06,0,0,1,1-.08l2.86-.07c2.42-.05,5.75-.15,9.43-.37s7-.54,9.4-.79l2.85-.29A3.83,3.83,0,0,1,613.37,186.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.41,205.6a11.37,11.37,0,0,0-1-4.2,11.2,11.2,0,0,0-2.83-3.69,13.47,13.47,0,0,0-5.05-2.62,19.06,19.06,0,0,0-10.35,0,14.44,14.44,0,0,0-3.87,2,3.53,3.53,0,0,1,.87-.82,10.87,10.87,0,0,1,2.88-1.5,18.41,18.41,0,0,1,10.61-.15,13.31,13.31,0,0,1,5.22,2.76,11.23,11.23,0,0,1,2.86,3.9,8.9,8.9,0,0,1,.74,3.16,5.56,5.56,0,0,1,0,.89Q616.44,205.6,616.41,205.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.08,202.84a15.2,15.2,0,0,1-.81,1.4c-.54.89-1.28,2.2-2.12,3.86s-1.75,3.68-2.68,6a42.68,42.68,0,0,0-2.53,7.56c-1.18,5.54-1.9,10.66-2.48,14.33-.27,1.78-.5,3.25-.67,4.37a9.4,9.4,0,0,1-.31,1.59,9.75,9.75,0,0,1,.11-1.62c.1-1,.27-2.54.5-4.39.5-3.69,1.15-8.81,2.34-14.4a41,41,0,0,1,2.59-7.62c1-2.28,1.92-4.29,2.81-5.94a41,41,0,0,1,2.27-3.8c.29-.44.53-.76.7-1S573.06,202.82,573.08,202.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.19,218.13a1,1,0,0,1-.05.32l-.2.93c-.19.82-.48,2-.88,3.56-.8,3.08-2,7.52-3.69,12.95a150.94,150.94,0,0,1-7,18.71,54.16,54.16,0,0,1-2.77,5.09,22.73,22.73,0,0,1-1.74,2.45,11.9,11.9,0,0,1-2.19,2.18A17.13,17.13,0,0,1,591,267a31,31,0,0,1-6.4,1,61.42,61.42,0,0,1-13.91-1.16c-2.21-.41-4.36-.9-6.44-1.42a59.14,59.14,0,0,1-6-1.79c-7.66-2.65-14.3-5.2-19.59-7.22l-.13-.06,0-.13c1-4.66,1.71-8.37,2.24-11,.26-1.25.47-2.22.62-2.92.07-.31.12-.56.17-.75a1,1,0,0,1,.07-.25.86.86,0,0,1,0,.26l-.12.76c-.13.7-.31,1.68-.53,2.93-.5,2.59-1.2,6.31-2.09,11l-.11-.19c5.3,2,12,4.48,19.62,7.1,1.92.64,3.88,1.28,6,1.76s4.21,1,6.41,1.39a61.81,61.81,0,0,0,13.8,1.14c4.27-.23,8.55-1.15,11.79-3.58a11.29,11.29,0,0,0,2.11-2.09,21.86,21.86,0,0,0,1.71-2.4,52.84,52.84,0,0,0,2.75-5,155,155,0,0,0,7.1-18.61c1.73-5.41,3-9.83,3.84-12.89.42-1.51.74-2.69,1-3.53.11-.38.2-.69.26-.92S615.19,218.13,615.19,218.13Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.68,457.26l-11.52-18.09,17.7-9.31,8.82,21.65S400.35,461.6,393.68,457.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.51,457.33l.51,1.07s-14.86,12.05-11.31,18.43l32.12-15.45a63.68,63.68,0,0,0-6.9-11.32C404.35,454.82,400.2,457.14,393.51,457.33Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.83,461.38a16.3,16.3,0,0,0-1.44-2.83l-31.22,15.88a4,4,0,0,0,.54,2.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.79,463.83s0-.32-.23-.74a3.93,3.93,0,0,0-3-2c-.48,0-.77.05-.76.1a9.38,9.38,0,0,1,2.29.87C394.2,462.82,394.67,463.88,394.79,463.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.89,462.05a3.36,3.36,0,0,0-1.64-2,3.43,3.43,0,0,0-2.48-.67,24,24,0,0,1,2.25,1A22.54,22.54,0,0,1,396.89,462.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,465.71a2.62,2.62,0,0,0-.81-2,2.72,2.72,0,0,0-1.84-1.12c-.05.12.8.53,1.52,1.39S391.86,465.75,392,465.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.83,461.49a2.39,2.39,0,0,0,0-1.48,7.22,7.22,0,0,0-.52-1.52c-.12-.27-.26-.55-.41-.84a2.28,2.28,0,0,0-.27-.46.74.74,0,0,0-.6-.31.6.6,0,0,0-.55.47,1.41,1.41,0,0,0,0,.58,4.38,4.38,0,0,0,.27.93,4.88,4.88,0,0,0,.86,1.38,2.53,2.53,0,0,0,1.19.87c0-.05-.43-.37-1-1.06a5.19,5.19,0,0,1-.72-1.33,4.72,4.72,0,0,1-.23-.86c-.06-.29,0-.58.15-.55s.35.23.49.53l.43.82a10.75,10.75,0,0,1,.58,1.43C390.8,460.92,390.76,461.48,390.83,461.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.54,461.5s.08,0,.24,0h.13l-.09-.12a4.73,4.73,0,0,0-1.3-1.05,6.09,6.09,0,0,0-1.2-.53q-.35-.1-.72-.18a1.24,1.24,0,0,0-.44,0,.66.66,0,0,0-.46.31.55.55,0,0,0,.14.68,1.81,1.81,0,0,0,.43.29,4.87,4.87,0,0,0,.82.36,5.3,5.3,0,0,0,1.5.27,2.36,2.36,0,0,0,1.36-.23c0-.07-.53,0-1.34-.07a5.88,5.88,0,0,1-1.38-.34,5.15,5.15,0,0,1-.76-.35c-.27-.14-.48-.34-.4-.4.1-.23.74,0,1.14.07a6.91,6.91,0,0,1,1.15.44,9.46,9.46,0,0,1,1.37.85l0-.11C390.61,461.45,390.53,461.48,390.54,461.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.15,461.92l-4.57-21.64,20.46-2.6.69,24.11S353,468.53,348.15,461.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.15,461.92l0,1.21s-19,5.36-18.24,12.85l36.74-1.52a66.11,66.11,0,0,0-1.91-13.54C359.44,464,354.57,464.47,348.15,461.92Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.69,474.46a16.3,16.3,0,0,0-.21-3.26l-36.06,2.28A4.17,4.17,0,0,0,330,476Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.7,468.6c.06,0,.13-.3.09-.8a4,4,0,0,0-.66-1.8,4.11,4.11,0,0,0-1.42-1.3c-.44-.23-.75-.27-.76-.22s1,.59,1.81,1.77A9.33,9.33,0,0,1,346.7,468.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.42,467.77a4.4,4.4,0,0,0-2.82-4.2c-.07.12.93.73,1.71,1.9A22.5,22.5,0,0,1,349.42,467.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.28,469.23a2.78,2.78,0,0,0,.05-2.22c-.38-1.23-1.23-1.9-1.3-1.8s.54.82.88,1.93S343.15,469.21,343.28,469.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.91,464.76a2.45,2.45,0,0,0,.61-1.39,7.61,7.61,0,0,0,.13-1.66c0-.31,0-.63,0-1a2.3,2.3,0,0,0-.07-.55.8.8,0,0,0-.44-.54.62.62,0,0,0-.72.23,1.69,1.69,0,0,0-.24.54,5.92,5.92,0,0,0-.12,1,5,5,0,0,0,.25,1.65,2.78,2.78,0,0,0,.77,1.32c.07,0-.25-.53-.47-1.4a5.73,5.73,0,0,1-.14-1.56,5,5,0,0,1,.13-.91c.06-.29.25-.54.38-.46s.23.37.24.71.05.64.07,1a10.15,10.15,0,0,1,0,1.59C344.12,464.21,343.85,464.73,343.91,464.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.63,464.65s.06.07.22.14l.12,0,0-.15a4.83,4.83,0,0,0-.8-1.52,6,6,0,0,0-.92-1,7.54,7.54,0,0,0-.61-.47,1.31,1.31,0,0,0-.41-.2.67.67,0,0,0-.57.11.58.58,0,0,0-.14.7,1.94,1.94,0,0,0,.29.45,5.89,5.89,0,0,0,.63.68,5.64,5.64,0,0,0,1.31.86,2.52,2.52,0,0,0,1.38.34c0-.07-.51-.2-1.24-.62a6.06,6.06,0,0,1-1.17-.88,5.2,5.2,0,0,1-.57-.65c-.21-.23-.31-.51-.22-.53.18-.18.72.27,1.05.53a7,7,0,0,1,.91.89,10.81,10.81,0,0,1,1,1.36l.08-.09C343.72,464.63,343.63,464.63,343.63,464.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.59,243.34a5.26,5.26,0,0,1,.54.54c.33.36.81.88,1.38,1.54,1.16,1.31,2.73,3.15,4.38,5.25s3.06,4.07,4,5.55c.47.74.84,1.35,1.07,1.78a6.42,6.42,0,0,1,.35.67,3.48,3.48,0,0,1-.43-.62c-.26-.41-.65-1-1.14-1.73-1-1.45-2.4-3.4-4.05-5.49s-3.19-4-4.31-5.29l-1.33-1.6A4.23,4.23,0,0,1,254.59,243.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.81,242.69a7.81,7.81,0,0,1-.51,8c-.32.46-.82.92-1.37.79s-.79-.85-.83-1.45a9.15,9.15,0,0,1,2.41-6.9,10.54,10.54,0,0,1-4.89,3.67c-.74.27-1.7.39-2.2-.22a1.83,1.83,0,0,1,.22-2.1,6.18,6.18,0,0,1,7-2.35,5.82,5.82,0,0,1-4.7-4.68c-.14-.9.11-2,1-2.26a1.91,1.91,0,0,1,1.52.5,7.43,7.43,0,0,1,2.88,5.49,6.51,6.51,0,0,1,2.87-6.54,2.27,2.27,0,0,1,2.28-.31c.88.52.9,1.79.62,2.78a8.48,8.48,0,0,1-4.91,5.48,4.86,4.86,0,0,1,4.45.72c.82.62,1.42,1.84.79,2.65s-1.84.55-2.73.14a12.22,12.22,0,0,1-4.22-3.22",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.93,248.2a26.83,26.83,0,0,1,.26-3.07,27.12,27.12,0,0,1,.89-2.95,8.19,8.19,0,0,0-1.15,6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.65,245.12a12.11,12.11,0,0,1,2-1.55c1.21-.68,2.33-.92,2.31-1a5.32,5.32,0,0,0-2.45.77A4.18,4.18,0,0,0,250.65,245.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.52,238.49a4.4,4.4,0,0,0,.68,2.36,3.82,3.82,0,0,0,1.72,1.75,11.49,11.49,0,0,1-1.48-1.88A21.07,21.07,0,0,1,252.52,238.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.17,241.42a1,1,0,0,0-1.15,1.33,2.54,2.54,0,0,1,.85-.22,4,4,0,0,1,.3-1.11",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23,236.7a3.29,3.29,0,0,0-.93.61,9.81,9.81,0,0,0-1.8,2,9.92,9.92,0,0,0-1.21,2.39,3.21,3.21,0,0,0-.25,1.07,19.52,19.52,0,0,1,1.68-3.3A18.65,18.65,0,0,1,259.23,236.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.94,236.88a.61.61,0,0,1-.06.23l-.23.63c-.21.55-.49,1.35-.81,2.34s-.65,2.19-.94,3.54a38.21,38.21,0,0,0-.69,4.43,38.66,38.66,0,0,0-.15,4.48c0,1.37.14,2.61.27,3.65s.25,1.87.35,2.44c0,.27.08.49.11.67a.8.8,0,0,1,0,.23s0-.07-.07-.22-.1-.4-.16-.66c-.13-.57-.28-1.4-.43-2.44a34.65,34.65,0,0,1-.32-3.67A36.84,36.84,0,0,1,270,248a38.35,38.35,0,0,1,.72-4.45,35.44,35.44,0,0,1,1-3.54c.34-1,.65-1.79.89-2.32l.27-.62A.72.72,0,0,1,272.94,236.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.67,235.17a7.81,7.81,0,0,1-7.92,1.42c-.52-.2-1.09-.58-1.09-1.14s.64-1,1.2-1.16a9.18,9.18,0,0,1,7.27.69,10.45,10.45,0,0,1-4.72-3.87c-.44-.65-.79-1.55-.32-2.18a1.85,1.85,0,0,1,2.1-.29,6.17,6.17,0,0,1,3.94,6.19,5.83,5.83,0,0,1,3.42-5.69c.84-.35,2-.38,2.43.42a1.92,1.92,0,0,1-.12,1.6,7.45,7.45,0,0,1-4.64,4.11,6.48,6.48,0,0,1,7,1.22,2.28,2.28,0,0,1,.85,2.14c-.29,1-1.53,1.3-2.55,1.27a8.51,8.51,0,0,1-6.5-3.46,4.84,4.84,0,0,1,.37,4.49c-.41.95-1.45,1.83-2.39,1.4s-1-1.65-.78-2.62a12,12,0,0,1,2.12-4.86",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.1,235.63a27.38,27.38,0,0,1,3-.49,29.77,29.77,0,0,1,3.07.16,6.7,6.7,0,0,0-3.09-.43A6.76,6.76,0,0,0,267.1,235.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.32,231.71a12,12,0,0,1,2,1.54c.94,1,1.45,2,1.53,2a5.27,5.27,0,0,0-1.33-2.19A4.1,4.1,0,0,0,269.32,231.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.2,231.93a4.54,4.54,0,0,0-2.13,1.23,3.83,3.83,0,0,0-1.29,2.09,10.83,10.83,0,0,1,1.48-1.89A21.69,21.69,0,0,1,276.2,231.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,235.21a1,1,0,0,0-1.57-.8,2.89,2.89,0,0,1,.42.77,4.41,4.41,0,0,1,1.15,0",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.54,238a3,3,0,0,0-.81-.75,9.91,9.91,0,0,0-4.94-1.89,3.54,3.54,0,0,0-1.11,0,13.64,13.64,0,0,1,6.86,2.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.44,245a5.33,5.33,0,0,1-.27.67c-.18.43-.45,1-.76,1.82-.64,1.55-1.45,3.7-2.2,6.13s-1.27,4.68-1.61,6.32l-.38,1.93a4.16,4.16,0,0,1-.16.71,4.24,4.24,0,0,1,.06-.72c.06-.47.16-1.13.31-2a55.73,55.73,0,0,1,3.81-12.47c.34-.77.63-1.38.84-1.8A3.38,3.38,0,0,1,277.44,245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.47,246.85a7.13,7.13,0,0,1-1.66.82,6.31,6.31,0,0,1-1.76.58,7.1,7.1,0,0,1,1.67-.81A6.67,6.67,0,0,1,279.47,246.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.07,246.54a.66.66,0,0,0-.38.54.88.88,0,0,0,.22.64,1,1,0,0,0,1.14.29,1,1,0,0,0,.64-1,.94.94,0,0,0-1.79-.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.9,246.67s0-.1.11-.24a.94.94,0,0,1,.61-.37,1,1,0,0,1,1,.41,1,1,0,0,1,.21.63,1.1,1.1,0,0,1-1.48,1,1.07,1.07,0,0,1-.71-.79.76.76,0,0,1,.21-.69c.14-.12.24-.13.24-.11s-.07.05-.16.17a.69.69,0,0,0-.11.59.89.89,0,0,0,.61.61.87.87,0,0,0,1-.3.83.83,0,0,0,0-1,.84.84,0,0,0-.77-.37,1,1,0,0,0-.56.26C279,246.6,278.92,246.68,278.9,246.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.63,246.45a.68.68,0,0,0-.38.55.9.9,0,0,0,.22.64,1.06,1.06,0,0,0,1.14.29,1,1,0,0,0,.64-1,1,1,0,0,0-.75-.89,1,1,0,0,0-1,.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.46,246.58s0-.1.1-.24a1,1,0,0,1,.62-.37,1,1,0,0,1,1,.42,1,1,0,0,1,.21.62,1.12,1.12,0,0,1-.82,1.07,1.13,1.13,0,0,1-.66,0,1.08,1.08,0,0,1-.71-.8.75.75,0,0,1,.21-.69c.13-.11.24-.12.24-.11s-.07.06-.17.18a.67.67,0,0,0-.11.58.94.94,0,0,0,.61.62.88.88,0,0,0,1-.3.84.84,0,0,0,0-1,.82.82,0,0,0-.77-.37,1,1,0,0,0-.56.26C272.52,246.51,272.48,246.59,272.46,246.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55,245.14a.66.66,0,0,0,.65.07.87.87,0,0,0,.46-.5,1,1,0,0,0-.29-1.14,1,1,0,0,0-1.16-.09,1,1,0,0,0-.42,1.08,1,1,0,0,0,.95.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.74,245.22s-.09.05-.26,0a1,1,0,0,1-.62-.36,1,1,0,0,1-.11-1.06,1,1,0,0,1,1.15-.6,1.06,1.06,0,0,1,.63.32,1.21,1.21,0,0,1,.29.59,1.08,1.08,0,0,1-.36,1,.72.72,0,0,1-.7.14c-.17,0-.22-.14-.21-.15s.08,0,.23.06a.69.69,0,0,0,.57-.18.94.94,0,0,0,.24-.84.89.89,0,0,0-.73-.71.85.85,0,0,0-.9.46.82.82,0,0,0,0,.85,1,1,0,0,0,.5.38C277.65,245.2,277.74,245.2,277.74,245.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.57,247.89a15.16,15.16,0,0,1,.52,2.13,17.38,17.38,0,0,1,.45,2.14,11,11,0,0,1-1-4.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.09,253.72a3.6,3.6,0,0,1,.71.16c.45.11,1.1.3,1.9.56a55.27,55.27,0,0,1,6.09,2.36,56.36,56.36,0,0,1,5.77,3.07c.71.43,1.28.8,1.67,1.07a3.43,3.43,0,0,1,.58.43,5,5,0,0,1-.64-.35c-.4-.24-1-.59-1.7-1-1.45-.83-3.47-1.93-5.79-3s-4.47-1.87-6-2.42c-.79-.28-1.43-.5-1.87-.64A5.6,5.6,0,0,1,252.09,253.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.12,256.46a7,7,0,0,1,1.6-.92,6.86,6.86,0,0,1,1.72-.7,6.78,6.78,0,0,1-1.61.92A7,7,0,0,1,252.12,256.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.15,256a.68.68,0,0,1,.66.07.9.9,0,0,1,.33.59,1.07,1.07,0,0,1-.54,1.05,1,1,0,0,1-1.15-.17,1,1,0,0,1-.16-1.15,1,1,0,0,1,1.07-.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.36,255.92s-.1,0-.25,0a1,1,0,0,0-.57.25.86.86,0,0,0,.54,1.47.92.92,0,0,0,.82-1.4.68.68,0,0,0-.51-.3c-.15,0-.23,0-.24,0s.06-.09.24-.11a.74.74,0,0,1,.65.3,1.08,1.08,0,0,1,.13,1.06,1.14,1.14,0,0,1-.42.51,1.07,1.07,0,0,1-.68.18,1.06,1.06,0,0,1-1-.84,1,1,0,0,1,.35-1,1,1,0,0,1,.68-.22C252.28,255.85,252.36,255.9,252.36,255.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.36,251.08a.66.66,0,0,1,.66.08.86.86,0,0,1,.33.59,1,1,0,0,1-.53,1,1,1,0,0,1-1.16-.16,1,1,0,0,1-.16-1.15.94.94,0,0,1,1.07-.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.57,251s-.1,0-.25,0a1,1,0,0,0-.57.25.85.85,0,0,0-.23.82.83.83,0,0,0,.78.64.87.87,0,0,0,.87-.53.89.89,0,0,0-.06-.86.65.65,0,0,0-.51-.3c-.15,0-.23,0-.24,0s.07-.08.24-.1a.75.75,0,0,1,.66.3,1.05,1.05,0,0,1,.12,1.06,1.18,1.18,0,0,1-.41.51,1.13,1.13,0,0,1-1.35-.09,1.1,1.1,0,0,1-.33-.58,1,1,0,0,1,.35-1,1,1,0,0,1,.68-.21A.43.43,0,0,1,256.57,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.12,253.89a.69.69,0,0,1-.39.54.89.89,0,0,1-.68,0,1,1,0,0,1-.65-1,1,1,0,0,1,.7-.93,1,1,0,0,1,1.08.41,1,1,0,0,1-.13,1.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.05,254.09s0-.08.11-.22a1,1,0,0,0,.05-.62.83.83,0,0,0-.61-.6.83.83,0,0,0-.94.37.91.91,0,0,0,.83,1.38.65.65,0,0,0,.51-.3c.09-.12.1-.21.12-.21s0,.09,0,.26a.75.75,0,0,1-.57.43,1.06,1.06,0,0,1-1-.4,1.11,1.11,0,0,1-.25-.61,1.07,1.07,0,0,1,.17-.69,1.1,1.1,0,0,1,.55-.45,1.07,1.07,0,0,1,.66,0,1,1,0,0,1,.72.79,1,1,0,0,1-.14.7C252.15,254.05,252.06,254.1,252.05,254.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,252.74a7,7,0,0,1,1.45,1.65,7.22,7.22,0,0,1,1.1,1.9,14.91,14.91,0,0,1-1.3-1.75A15.62,15.62,0,0,1,256.81,252.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.19,267.05a2.37,2.37,0,0,1-.24-.39l-.6-1.17c-.53-1-1.24-2.51-2.05-4.38a90.2,90.2,0,0,1-7.23-31c-.1-2-.13-3.69-.1-4.84,0-.52,0-.95,0-1.31a2.77,2.77,0,0,1,0-.46,2.77,2.77,0,0,1,0,.46c0,.36,0,.79,0,1.31,0,1.14.08,2.79.2,4.83A95.92,95.92,0,0,0,269.5,261c.79,1.88,1.46,3.39,2,4.42l.55,1.19C272.13,266.9,272.19,267.05,272.19,267.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,224.41a10.74,10.74,0,0,1-9,6.4c-.77.05-1.7-.08-2-.78s.23-1.58.82-2.15a12.69,12.69,0,0,1,9.47-3.39,14.41,14.41,0,0,1-8.15-2.06c-.93-.56-1.89-1.47-1.67-2.53s1.41-1.49,2.45-1.59a8.51,8.51,0,0,1,8.53,5.4,8,8,0,0,1,.94-9.07c.83-.93,2.28-1.67,3.27-.9a2.66,2.66,0,0,1,.78,2.06,10.23,10.23,0,0,1-3.39,7.83,8.93,8.93,0,0,1,9.48-2.58,3.14,3.14,0,0,1,2.31,2.17c.21,1.39-1.14,2.51-2.43,3.06a11.71,11.71,0,0,1-10.12-.5,6.67,6.67,0,0,1,3.08,5.38c0,1.42-.75,3.12-2.16,3.13s-2.17-1.49-2.51-2.8a16.81,16.81,0,0,1-.2-7.3",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.33,228.24a33.72,33.72,0,0,1,3.51-2.38,33.15,33.15,0,0,1,3.93-1.6,9.36,9.36,0,0,0-4.11,1.26A9.21,9.21,0,0,0,253.33,228.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8,222.06a16.22,16.22,0,0,1,3.36.76c1.76.71,3,1.7,3.07,1.6a7.24,7.24,0,0,0-2.94-1.95A5.68,5.68,0,0,0,253.8,222.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.5,218.32a6.19,6.19,0,0,0-1.93,2.77,5.23,5.23,0,0,0-.39,3.35,15.53,15.53,0,0,1,.74-3.21C261.59,219.54,262.6,218.4,262.5,218.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.66,223.7a1.33,1.33,0,0,0-1.18-.84,1.35,1.35,0,0,0-1.24.76,3.61,3.61,0,0,1,1,.71,5.39,5.39,0,0,1,1.44-.63",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23,224a4.76,4.76,0,0,0-1.46-.46,13.8,13.8,0,0,0-3.66-.23,13.43,13.43,0,0,0-3.59.77,4.55,4.55,0,0,0-1.37.66,26.64,26.64,0,0,1,5-1.05A25.92,25.92,0,0,1,270.23,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.12,277.69,278.78,252s-2.83,1.81-5.24,3.4l-1.21-5.77-17.26,6.45,20.34,24.1,1.4-.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.12,277.69l-.29.17-.89.49c-.78.43-2,1-3.47,1.91l-.09.05-.06-.08c-4.06-4.7-11.54-13.48-20.45-24l-.23-.27.34-.13,9.11-3.41,8.15-3,.28-.1.06.29,1.2,5.77-.38-.15,5.25-3.39.34-.22,0,.4c.36,7.64.65,14.07.87,18.65.08,2.21.16,4,.21,5.23,0,.57,0,1,0,1.38a3.15,3.15,0,0,1,0,.46,3.9,3.9,0,0,1-.06-.5c0-.36-.06-.82-.1-1.4-.09-1.27-.2-3-.34-5.27-.26-4.55-.63-10.94-1.07-18.53l.35.19-5.23,3.41-.3.2-.07-.36c-.4-1.86-.8-3.79-1.22-5.77l.34.19-8.15,3.05-9.11,3.4.1-.41c8.88,10.55,16.28,19.4,20.24,24.19l-.15,0c1.51-.85,2.69-1.38,3.5-1.78l.93-.44A1.39,1.39,0,0,1,280.12,277.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.08,290.6s-7.21-6.13-9.37-9.47-4.16-6.76-5.82-6.85c0,0-2.11,2.41-4,2.16s-3.89-.59-3.89-.59-1.41.42-.41,2.4l1.24,1.45a2.14,2.14,0,0,0-.06,2.88,3.24,3.24,0,0,0,.43,3.47,5,5,0,0,0,2.57,3.82,12.83,12.83,0,0,0,5.81,1.74l4.82,6.27Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.54,301.57s-1.16,4.66-.91,6.42a53.16,53.16,0,0,0,1.72,6l6.66,4.33s5.06-7,6.55-9.71,3.56-4.43,2.72-5.61-2.27.24-2.27.24,2.14-5,.91-6.43-2.33,1.75-2.33,1.75,1.22-3-.3-4.24-3.71,5.06-3.71,5.06.74-4.38-1.14-4.84-5.08,11-5.08,11-.14-3.38-.9-4S395.54,301.57,395.54,301.57Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.74,250.74c-1.89-1.65-6.5-1.24-9-1.51s-2.33-12.64-14.11-9.29l-.32,36a6.76,6.76,0,0,0,12.34-5.29,6.1,6.1,0,1,0,8.57-8.66,5.43,5.43,0,0,0,5.15-4.57A7.52,7.52,0,0,0,385.74,250.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.74,251.67A31.45,31.45,0,0,1,334,245.3l6.58,33.5c-1.11,3-5.61,3.73-8.06,1.64s-2.82-5.93-1.49-8.86a5.35,5.35,0,1,1-5-9.23c-3-.22-6.56-.91-7.52-3.73C317.68,256.05,319.67,253.43,321.74,251.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.9,247.19a5.46,5.46,0,0,1-2.49-2.3,5.63,5.63,0,0,1,.45-6.23,5.06,5.06,0,0,1,1.92-1.47,8.39,8.39,0,0,1,5.63-.21h0c2.77-3.56,8.64-4.83,10.2-5.11,5-.92,9.22-.78,14.53,2.43,4.05,2.46,5.56,9.29,4.76,14-7.69,2.68-11.91,3-18.82,7.29-3.73,2.33-7.76,5.25-12.08,4.43a7.64,7.64,0,0,1-4.09-12.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.86,252.44c.64-6.12,7.5-12,13.59-11.08L368.13,246l-.2,3.3-5.31,35,.09,2.73s.06,16.24-11,15c-10-1.08-8.7-12.34-8.7-12.34l.35-7s-8.07-.66-9.27-11C333.45,266.58,334.15,259.24,334.86,252.44Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.15,261.26a1.32,1.32,0,0,0,1.21,1.38,1.26,1.26,0,0,0,1.4-1.13,1.31,1.31,0,0,0-1.21-1.37A1.25,1.25,0,0,0,337.15,261.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.44,258c.16.18,1.18-.51,2.59-.45s2.42.81,2.58.64-.08-.39-.51-.73a3.57,3.57,0,0,0-2.06-.73,3.49,3.49,0,0,0-2.07.57C336.52,257.57,336.36,257.87,336.44,258Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.77,262.18a1.31,1.31,0,0,0,1.21,1.38,1.26,1.26,0,0,0,1.4-1.13,1.32,1.32,0,0,0-1.21-1.38A1.26,1.26,0,0,0,348.77,262.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.42,258.71c.16.18,1.18-.52,2.59-.46s2.42.81,2.58.65-.07-.39-.51-.74a3.71,3.71,0,0,0-2.06-.73A3.49,3.49,0,0,0,350,258C349.5,258.32,349.34,258.63,349.42,258.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.89,267.56a12.69,12.69,0,0,0-2.28-.44c-.36-.05-.7-.12-.76-.32s.08-.51.27-.83c.36-.68.73-1.38,1.13-2.12s2.52-5.13,2.56-5.56a32.91,32.91,0,0,0-3.13,5.37l-1.08,2.13a1.33,1.33,0,0,0-.22,1.11.87.87,0,0,0,.58.44,2.49,2.49,0,0,0,.61.1A10.42,10.42,0,0,0,344.89,267.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.25,282.72a26.08,26.08,0,0,0,13.85-3.1s-3.74,7.45-13.93,6.07Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.38,268.22c-.23,0-.3,1.51-1.65,2.55s-3,.79-3,1,.35.31,1,.36a3.84,3.84,0,0,0,2.5-.76,3.26,3.26,0,0,0,1.28-2.14C349.64,268.6,349.48,268.22,349.38,268.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.08,254c.15.44,1.38.17,2.84.33s2.67.63,2.85.22c.07-.2-.15-.61-.65-1a4,4,0,0,0-2.14-.87,3.65,3.65,0,0,0-2.19.45C350.27,253.44,350,253.81,350.08,254Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.59,253.1c.22.41,1.28.13,2.5.25s2.23.52,2.51.15c.13-.18,0-.58-.4-1a3.31,3.31,0,0,0-4-.32C336.69,252.53,336.5,252.9,336.59,253.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,246.67a14.91,14.91,0,0,1,9.45-6.65,24.45,24.45,0,0,1,11.74.39,72.85,72.85,0,0,1,11.12,4.13,3.86,3.86,0,0,1,2.22,1.71,3.82,3.82,0,0,1,.16,1.93q-.74,8.19-1.46,16.4l-1.59,3.31c-1.77,0-3.23-1.39-4.34-2.77A24.52,24.52,0,0,1,358,247.74a8,8,0,0,0-1.05,2.34,2.72,2.72,0,0,1-1.69,1.83c-1.4.33-2.51-1.29-2.68-2.72s.13-3-.53-4.25a16.51,16.51,0,0,1-5.61,4.79c-1,.53-2.4.93-3.29.17a2.22,2.22,0,0,1-.53-2.29,6.7,6.7,0,0,1,1.25-2.12,13,13,0,0,1-6.45,3.57,1.75,1.75,0,0,1-1.57-.19C335.29,248.34,335.58,247.36,336,246.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.32,260.68c.16-.06,6.36-1.56,5.86,4.68s-6.65,4.44-6.65,4.26S365.32,260.68,365.32,260.68Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.63,267.42s.1.08.27.18a1.06,1.06,0,0,0,.81.08,2.69,2.69,0,0,0,1.44-2.31,3.54,3.54,0,0,0-.18-1.58,1.26,1.26,0,0,0-.75-.9.55.55,0,0,0-.66.25c-.1.17-.07.29-.1.3s-.13-.11-.06-.37a.72.72,0,0,1,.28-.37.83.83,0,0,1,.61-.11,1.53,1.53,0,0,1,1.06,1.06,3.78,3.78,0,0,1,.24,1.77,2.84,2.84,0,0,1-1.8,2.56,1.16,1.16,0,0,1-1-.24C366.62,267.57,366.6,267.43,366.63,267.42Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.43,235.81a7.19,7.19,0,0,0,2.18-7.93,5.35,5.35,0,0,0-2.36-2.88,6.41,6.41,0,0,0-4.76-.24,10.41,10.41,0,0,0-7.1,6.55,8.18,8.18,0,0,0,2.77,9l5.62,1.75a2.42,2.42,0,0,0,4.31-1.48,2.56,2.56,0,1,0-.66-4.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.24,347.42s6.64,16.38,6.64,22.84,4.53,33.23,4.53,33.23l17.33,43.84-18.12,9.5S373.71,428,370.45,415.69s-7.6-32.19-7.6-32.19l-1-37.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,355.12s.27,20.45,1.2,32.35c.63,8.09,4.68,32.64,6.45,39.42s4.9,34.47,4.9,34.47l20.69-.77c.3-2.16-2.06-73.83-2.65-74.76s6-12.18,6.9-22.34a57.13,57.13,0,0,0-1.78-19.09l-34.12,2.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.44,362.21a4,4,0,0,1,.29.93,24.22,24.22,0,0,1,.49,2.6,28,28,0,0,1,.24,3.92,27.71,27.71,0,0,1-.51,4.78,34.75,34.75,0,0,1-2.83,8.25c-.49,1-.91,1.8-1.23,2.33a3.34,3.34,0,0,1-.53.81c-.07,0,.56-1.26,1.45-3.29a39.91,39.91,0,0,0,2.67-8.19,30.33,30.33,0,0,0,.53-4.7,30.74,30.74,0,0,0-.13-3.87C367.66,363.58,367.36,362.23,367.44,362.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.06,285.86c.43.14,8.26.38,11.69,8a96.1,96.1,0,0,1,4.51,11.69l5.38,8.28,2.41-2.72,9.23,5.27s-3.57,11.63-11.64,12.43-14.18-10.49-15.16-11.61S373.21,307,373.21,307Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.45,344.84c-1.44-2.3-2.88-10.08-2.88-10.08s1.73-44.17,1.73-44.61-5.91-3.6-5.91-3.6l-12.24-3.36s-.13,1.76-6.61,3.2a50.14,50.14,0,0,1-14.11.58l-6.94,1.31a18.59,18.59,0,0,0-4.85,1.62c-5.72,2.84-21.44,10.22-21.44,10.22l-18-15.22L281.37,295l20.08,21.23c3,2,4.56,4.46,10.48,3.66l19.44-8.56c-.2,11.49-.5,38.59-.5,38.59l.23,9.05s18.76-8.47,30.85-9.05A90.34,90.34,0,0,1,384,351.62S383.89,347.14,382.45,344.84Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.32,294.23a11.22,11.22,0,0,1,.06,1.6c0,1,0,2.51-.05,4.35-.07,3.67-.26,8.74-.55,14.33s-.58,10.58-.78,14.32c-.11,1.78-.2,3.24-.27,4.34a10.33,10.33,0,0,1-.16,1.59,11,11,0,0,1,0-1.59c0-1,.06-2.52.12-4.35.12-3.67.36-8.74.64-14.33s.51-10.58.69-14.32c.08-1.78.15-3.24.2-4.35A9,9,0,0,1,381.32,294.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,321.43a24.82,24.82,0,0,0-.77-4,25.44,25.44,0,0,0-1.86-3.63,8.29,8.29,0,0,1,2.63,7.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.93,307.36a5.56,5.56,0,0,1-1,.57c-.65.35-1.6.83-2.78,1.4-2.36,1.15-5.66,2.67-9.36,4.23s-7.08,2.86-9.55,3.76c-1.24.44-2.24.79-2.94,1a4.22,4.22,0,0,1-1.1.3,5.51,5.51,0,0,1,1-.48l2.89-1.16c2.43-1,5.8-2.33,9.49-3.89s7-3,9.4-4.09l2.84-1.25A4.51,4.51,0,0,1,340.93,307.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.26,308.87a40.91,40.91,0,0,1,1.06-8.82,20.71,20.71,0,0,1-.3,4.44A21.18,21.18,0,0,1,308.26,308.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.87,276.14a5.73,5.73,0,0,1-.27-1c-.17-.78-.38-1.72-.62-2.83-.55-2.52-1.25-5.77-2-9.36s-1.49-7-1.95-9.39c-.2-1.11-.38-2.07-.52-2.85a8.75,8.75,0,0,1-.15-1.06,5.43,5.43,0,0,1,.27,1c.17.78.38,1.73.62,2.84.55,2.52,1.25,5.77,2,9.36s1.49,7,1.95,9.38c.2,1.12.38,2.07.52,2.86A8.48,8.48,0,0,1,277.87,276.14Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding);
export default __webpack_public_path__ + "static/media/landing.73f27d4334cfbabcce870ec445f6c1e2.svg";
export { ForwardRef as ReactComponent };